"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6795],{

/***/ 16795:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "BL": function() { return /* binding */ LoadingScreenStyle; },
  "oN": function() { return /* binding */ Weekdays; },
  "F1": function() { return /* binding */ colorSetter; },
  "i2": function() { return /* binding */ componentShowInMenu; },
  "qi": function() { return /* binding */ createSlug; },
  "ZP": function() { return /* binding */ RBPartnerPortal_PartnerPortalLayout; },
  "y0": function() { return /* binding */ isSubNameAvailable; },
  "HG": function() { return /* binding */ topBarAvailable; },
  "Lh": function() { return /* binding */ topBarHasLeftData; },
  "T0": function() { return /* binding */ topBarHasRightData; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./utils/contexts/LayoutContext.tsx + 65 modules
var LayoutContext = __webpack_require__(92609);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Box/Box.js
var Box = __webpack_require__(30120);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/CircularProgress/CircularProgress.js + 1 modules
var CircularProgress = __webpack_require__(70754);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./components/RBPartnerPortal/templates/AutoraTemplate/Autora.js
/* provided dependency */ var $ = __webpack_require__(19755);
var AutoraJS = {
    // Main init function
    init: function init() {
        this.config();
        this.events();
    },
    // Define vars for caching
    config: function config() {
        this.config = {
            $window: $(window),
            $document: $(document)
        };
    },
    // Events
    events: function events() {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var self = this;
        // Run on document ready
        self.config.$document.ready(function() {
            // PreLoader
            self.preLoader();
            // Header Fixed
            self.headerFixed();
            // Mobile Navigation
            self.mobileNav();
            // Scroll to Top
            self.scrollToTop();
            self.flatSpacer();
            self.flatContentBox;
        });
    },
    // PreLoader
    preLoader: function preLoader() {
        $("#layout-loader").delay(1000).fadeOut(500);
    },
    // Header Fixed
    headerFixed: function headerFixed() {
        if ($("div").hasClass("header-fixed")) {
            setTimeout(function() {
                var nav = $("#site-header");
                if (nav.length) {
                    var offsetTop = nav.offset().top, headerHeight = nav.height(), injectSpace = $('<div style="height: '.concat(headerHeight, 'px; display: none;" />')).insertAfter(nav);
                    var scrollFunction = function scrollFunction() {
                        var nav = $("#site-header");
                        if ($(window).scrollTop() > offsetTop) {
                            nav.addClass("is-fixed");
                            injectSpace.show();
                        } else {
                            nav.removeClass("is-fixed");
                            injectSpace.hide();
                        }
                        if ($(window).scrollTop() > 100) {
                            nav.addClass("is-small");
                        } else {
                            nav.removeClass("is-small");
                        }
                    };
                    $(window).on("load", scrollFunction);
                    $(window).on("scroll", scrollFunction);
                }
            }, 2000);
        }
    },
    // Mobile Navigation
    mobileNav: function mobileNav() {
        var navFunction = function navFunction() {
            var mode = "desktop";
            var wrapMenu = $("#site-header-inner .wrap-inner");
            var navExtw = $(".nav-extend.active");
            var navExt = $(".nav-extend.active").children();
            if (matchMedia("only screen and (max-width: 1199px)").matches) mode = "mobile";
            if (mode === "mobile") {
                $("#main-nav").attr("id", "main-nav-mobi").appendTo("#site-header").hide().children(".menu").append(navExt).find("li:has(ul)").children("ul").removeAttr("style").hide().before('<span class="arrow"></span>');
            } else {
                if ($("div").is(".header-style-3")) wrapMenu = $(".site-navigation-wrap .inner");
                $("#main-nav-mobi").attr("id", "main-nav").removeAttr("style").prependTo(wrapMenu).find(".ext").appendTo(navExtw).parent().siblings("#main-nav").find(".sub-menu").removeAttr("style").prev().remove();
                $(".mobile-button").removeClass("active");
            }
        };
        $(window).on("resize", navFunction);
        $(window).on("load", navFunction);
        $(window).on("DOMSubtreeModified", navFunction);
        $(document).on("click", ".mobile-button", function() {
            $(this).toggleClass("active");
            $("#main-nav-mobi").slideToggle();
        });
        $(document).on("click", "#main-nav-mobi .arrow", function() {
            $(this).toggleClass("active").next().slideToggle();
        });
    },
    // Scroll to Top
    scrollToTop: function scrollToTop() {
        var scrollFunction = function scrollFunction() {
            if ($(this).scrollTop() > 100) {
                $("#scroll-top").addClass("show");
            } else {
                $("#scroll-top").removeClass("show");
            }
        };
        $("#scroll-top").on("click", function() {
            $("html, body").animate({
                scrollTop: 0
            }, 1000);
            return false;
        });
        $(window).on("scroll", scrollFunction);
    },
    // Spacer append (.themesflat-spacer classes)
    flatSpacer: function flatSpacer() {
        var spacerFunction = function spacerFunction() {
            var mode = "desktop";
            if (matchMedia("only screen and (max-width: 991px)").matches) mode = "mobile";
            if (matchMedia("only screen and (max-width: 767px)").matches) mode = "smobile";
            $(".themesflat-spacer").each(function() {
                if (mode === "desktop") {
                    $(this).attr("style", "height:" + $(this).data("desktop") + "px");
                } else if (mode == "mobile") {
                    $(this).attr("style", "height:" + $(this).data("mobile") + "px");
                } else {
                    $(this).attr("style", "height:" + $(this).data("smobile") + "px");
                }
            });
        };
        $(window).on("load", spacerFunction);
        $(window).on("resize", spacerFunction);
        $(window).on("DOMSubtreeModified", spacerFunction);
    },
    // Content box margin change (.themesflat-content-box classes)
    flatContentBox: function flatContentBox() {
        var contentBoxFunction = function contentBoxFunction() {
            var mode = "desktop";
            if (matchMedia("only screen and (max-width: 1199px)").matches) mode = "mobile";
            $(".themesflat-content-box").each(function() {
                var margin = $(this).data("margin");
                if (margin) {
                    if (mode === "desktop") {
                        $(this).attr("style", "margin:" + $(this).data("margin"));
                    } else if (mode === "mobile") {
                        $(this).attr("style", "margin:" + $(this).data("mobilemargin"));
                    }
                }
            });
        };
        $(window).on("load", contentBoxFunction);
        $(window).on("resize", contentBoxFunction);
        $(window).on("DOMSubtreeModified", contentBoxFunction);
    }
};


// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_type_of.mjs
var _type_of = __webpack_require__(82222);
;// CONCATENATED MODULE: ./components/RBPartnerPortal/_common/bootstrap.js
/* provided dependency */ var jQuery = __webpack_require__(19755);
/* eslint-disable @typescript-eslint/no-unused-vars */ 

var bootstrap = {
    init: function init() {
        /*!
 * Bootstrap v4.0.0-alpha.6 (https://getbootstrap.com)
 * Copyright 2011-2017 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 */ if (typeof jQuery === "undefined") {
            throw new Error("Bootstrap's JavaScript requires jQuery. jQuery must be included before Bootstrap's JavaScript.");
        }
        +function($) {
            var version = $.fn.jquery.split(" ")[0].split(".");
            if (version[0] < 2 && version[1] < 9 || version[0] == 1 && version[1] == 9 && version[2] < 1 || version[0] >= 4) {
                throw new Error("Bootstrap's JavaScript requires at least jQuery v1.9.1 but less than v4.0.0");
            }
        }(jQuery);
        +function() {
            var _possibleConstructorReturn = function _possibleConstructorReturn(self, call) {
                if (!self) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return call && (typeof call === "object" || typeof call === "function") ? call : self;
            };
            var _inherits = function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0,_type_of/* default */.Z)(superClass)));
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            };
            var _classCallCheck = function _classCallCheck(instance, Constructor) {
                if (!(0,_instanceof/* default */.Z)(instance, Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            };
            var _typeof = typeof Symbol === "function" && (0,_type_of/* default */.Z)(Symbol.iterator) === "symbol" ? function _typeof(obj) {
                return typeof obj === "undefined" ? "undefined" : (0,_type_of/* default */.Z)(obj);
            } : function(obj) {
                return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : (0,_type_of/* default */.Z)(obj);
            };
            var _createClass = function() {
                var defineProperties = function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                };
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            /**
 * --------------------------------------------------------------------------
 * Bootstrap (v4.0.0-alpha.6): util.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */ var Util = function($) {
                var toType = // shoutout AngusCroll (https://goo.gl/pxwQGp)
                function toType(obj) {
                    return ({}).toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
                };
                var isElement = function isElement(obj) {
                    return (obj[0] || obj).nodeType;
                };
                var getSpecialTransitionEndEvent = function getSpecialTransitionEndEvent() {
                    return {
                        bindType: transition.end,
                        delegateType: transition.end,
                        handle: function handle(event) {
                            if ($(event.target).is(this)) {
                                return event.handleObj.handler.apply(this, arguments); // eslint-disable-line prefer-rest-params
                            }
                            return undefined;
                        }
                    };
                };
                var transitionEndTest = function transitionEndTest() {
                    if (window.QUnit) {
                        return false;
                    }
                    var el = document.createElement("bootstrap");
                    for(var name in TransitionEndEvent){
                        if (el.style[name] !== undefined) {
                            return {
                                end: TransitionEndEvent[name]
                            };
                        }
                    }
                    return false;
                };
                var transitionEndEmulator = function transitionEndEmulator(duration) {
                    var called = false;
                    $(this).one(Util.TRANSITION_END, function() {
                        called = true;
                    });
                    setTimeout(function() {
                        if (!called) {
                            Util.triggerTransitionEnd(this);
                        }
                    }, duration);
                    return this;
                };
                var setTransitionEndSupport = function setTransitionEndSupport() {
                    transition = transitionEndTest();
                    $.fn.emulateTransitionEnd = transitionEndEmulator;
                    if (Util.supportsTransitionEnd()) {
                        $.event.special[Util.TRANSITION_END] = getSpecialTransitionEndEvent();
                    }
                };
                /**
   * ------------------------------------------------------------------------
   * Private TransitionEnd Helpers
   * ------------------------------------------------------------------------
   */ var transition = false;
                var MAX_UID = 1000000;
                var TransitionEndEvent = {
                    WebkitTransition: "webkitTransitionEnd",
                    MozTransition: "transitionend",
                    OTransition: "oTransitionEnd otransitionend",
                    transition: "transitionend"
                };
                /**
   * --------------------------------------------------------------------------
   * Public Util Api
   * --------------------------------------------------------------------------
   */ var Util = {
                    TRANSITION_END: "bsTransitionEnd",
                    getUID: function getUID(prefix) {
                        do {
                            // eslint-disable-next-line no-bitwise
                            prefix += ~~(Math.random() * MAX_UID); // "~~" acts like a faster Math.floor() here
                        }while (document.getElementById(prefix));
                        return prefix;
                    },
                    getSelectorFromElement: function getSelectorFromElement(element) {
                        var selector = element.getAttribute("data-target");
                        if (!selector) {
                            selector = element.getAttribute("href") || "";
                            selector = /^#[a-z]/i.test(selector) ? selector : null;
                        }
                        return selector;
                    },
                    reflow: function reflow(element) {
                        return element.offsetHeight;
                    },
                    triggerTransitionEnd: function triggerTransitionEnd(element) {
                        $(element).trigger(transition.end);
                    },
                    supportsTransitionEnd: function supportsTransitionEnd() {
                        return Boolean(transition);
                    },
                    typeCheckConfig: function typeCheckConfig(componentName, config, configTypes) {
                        for(var property in configTypes){
                            if (configTypes.hasOwnProperty(property)) {
                                var expectedTypes = configTypes[property];
                                var value = config[property];
                                var valueType = value && isElement(value) ? "element" : toType(value);
                                if (!new RegExp(expectedTypes).test(valueType)) {
                                    throw new Error(componentName.toUpperCase() + ": " + ('Option "' + property + '" provided type "' + valueType + '" ') + ('but expected type "' + expectedTypes + '".'));
                                }
                            }
                        }
                    }
                };
                setTransitionEndSupport();
                return Util;
            }(jQuery);
            /**
 * --------------------------------------------------------------------------
 * Bootstrap (v4.0.0-alpha.6): alert.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */ var Alert = function($) {
                /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */ var NAME = "alert";
                var VERSION = "4.0.0-alpha.6";
                var DATA_KEY = "bs.alert";
                var EVENT_KEY = "." + DATA_KEY;
                var DATA_API_KEY = ".data-api";
                var JQUERY_NO_CONFLICT = $.fn[NAME];
                var TRANSITION_DURATION = 150;
                var Selector = {
                    DISMISS: '[data-dismiss="alert"]'
                };
                var Event = {
                    CLOSE: "close" + EVENT_KEY,
                    CLOSED: "closed" + EVENT_KEY,
                    CLICK_DATA_API: "click" + EVENT_KEY + DATA_API_KEY
                };
                var ClassName = {
                    ALERT: "alert",
                    FADE: "fade",
                    SHOW: "show"
                };
                /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */ var Alert = function() {
                    function Alert(element) {
                        _classCallCheck(this, Alert);
                        this._element = element;
                    }
                    // getters
                    // public
                    Alert.prototype.close = function close(element) {
                        element = element || this._element;
                        var rootElement = this._getRootElement(element);
                        var customEvent = this._triggerCloseEvent(rootElement);
                        if (customEvent.isDefaultPrevented()) {
                            return;
                        }
                        this._removeElement(rootElement);
                    };
                    Alert.prototype.dispose = function dispose() {
                        $.removeData(this._element, DATA_KEY);
                        this._element = null;
                    };
                    // private
                    Alert.prototype._getRootElement = function _getRootElement(element) {
                        var selector = Util.getSelectorFromElement(element);
                        var parent = false;
                        if (selector) {
                            parent = $(selector)[0];
                        }
                        if (!parent) {
                            parent = $(element).closest("." + ClassName.ALERT)[0];
                        }
                        return parent;
                    };
                    Alert.prototype._triggerCloseEvent = function _triggerCloseEvent(element) {
                        var closeEvent = $.Event(Event.CLOSE);
                        $(element).trigger(closeEvent);
                        return closeEvent;
                    };
                    Alert.prototype._removeElement = function _removeElement(element) {
                        $(element).removeClass(ClassName.SHOW);
                        if (!Util.supportsTransitionEnd() || !$(element).hasClass(ClassName.FADE)) {
                            this._destroyElement(element);
                            return;
                        }
                        $(element).one(Util.TRANSITION_END, function(event) {
                            return this._destroyElement(element, event);
                        }).emulateTransitionEnd(TRANSITION_DURATION);
                    };
                    Alert.prototype._destroyElement = function _destroyElement(element) {
                        $(element).detach().trigger(Event.CLOSED).remove();
                    };
                    // static
                    Alert._jQueryInterface = function _jQueryInterface(config) {
                        return this.each(function() {
                            var $element = $(this);
                            var data = $element.data(DATA_KEY);
                            if (!data) {
                                data = new Alert(this);
                                $element.data(DATA_KEY, data);
                            }
                            if (config === "close") {
                                data[config](this);
                            }
                        });
                    };
                    Alert._handleDismiss = function _handleDismiss(alertInstance) {
                        return function(event) {
                            if (event) {
                                event.preventDefault();
                            }
                            alertInstance.close(this);
                        };
                    };
                    _createClass(Alert, null, [
                        {
                            key: "VERSION",
                            get: function get() {
                                return VERSION;
                            }
                        }
                    ]);
                    return Alert;
                }();
                /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */ $(document).on(Event.CLICK_DATA_API, Selector.DISMISS, Alert._handleDismiss(new Alert()));
                /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */ $.fn[NAME] = Alert._jQueryInterface;
                $.fn[NAME].Constructor = Alert;
                $.fn[NAME].noConflict = function() {
                    $.fn[NAME] = JQUERY_NO_CONFLICT;
                    return Alert._jQueryInterface;
                };
                return Alert;
            }(jQuery);
            /**
 * --------------------------------------------------------------------------
 * Bootstrap (v4.0.0-alpha.6): button.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */ var Button = function($) {
                /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */ var NAME = "button";
                var VERSION = "4.0.0-alpha.6";
                var DATA_KEY = "bs.button";
                var EVENT_KEY = "." + DATA_KEY;
                var DATA_API_KEY = ".data-api";
                var JQUERY_NO_CONFLICT = $.fn[NAME];
                var ClassName = {
                    ACTIVE: "active",
                    BUTTON: "btn",
                    FOCUS: "focus"
                };
                var Selector = {
                    DATA_TOGGLE_CARROT: '[data-toggle^="button"]',
                    DATA_TOGGLE: '[data-toggle="buttons"]',
                    INPUT: "input",
                    ACTIVE: ".active",
                    BUTTON: ".btn"
                };
                var Event = {
                    CLICK_DATA_API: "click" + EVENT_KEY + DATA_API_KEY,
                    FOCUS_BLUR_DATA_API: "focus" + EVENT_KEY + DATA_API_KEY + " " + ("blur" + EVENT_KEY + DATA_API_KEY)
                };
                /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */ var Button = function() {
                    function Button(element) {
                        _classCallCheck(this, Button);
                        this._element = element;
                    }
                    // getters
                    // public
                    Button.prototype.toggle = function toggle() {
                        var triggerChangeEvent = true;
                        var rootElement = $(this._element).closest(Selector.DATA_TOGGLE)[0];
                        if (rootElement) {
                            var input = $(this._element).find(Selector.INPUT)[0];
                            if (input) {
                                if (input.type === "radio") {
                                    if (input.checked && $(this._element).hasClass(ClassName.ACTIVE)) {
                                        triggerChangeEvent = false;
                                    } else {
                                        var activeElement = $(rootElement).find(Selector.ACTIVE)[0];
                                        if (activeElement) {
                                            $(activeElement).removeClass(ClassName.ACTIVE);
                                        }
                                    }
                                }
                                if (triggerChangeEvent) {
                                    input.checked = !$(this._element).hasClass(ClassName.ACTIVE);
                                    $(input).trigger("change");
                                }
                                input.focus();
                            }
                        }
                        this._element.setAttribute("aria-pressed", !$(this._element).hasClass(ClassName.ACTIVE));
                        if (triggerChangeEvent) {
                            $(this._element).toggleClass(ClassName.ACTIVE);
                        }
                    };
                    Button.prototype.dispose = function dispose() {
                        $.removeData(this._element, DATA_KEY);
                        this._element = null;
                    };
                    // static
                    Button._jQueryInterface = function _jQueryInterface(config) {
                        return this.each(function() {
                            var data = $(this).data(DATA_KEY);
                            if (!data) {
                                data = new Button(this);
                                $(this).data(DATA_KEY, data);
                            }
                            if (config === "toggle") {
                                data[config]();
                            }
                        });
                    };
                    _createClass(Button, null, [
                        {
                            key: "VERSION",
                            get: function get() {
                                return VERSION;
                            }
                        }
                    ]);
                    return Button;
                }();
                /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */ $(document).on(Event.CLICK_DATA_API, Selector.DATA_TOGGLE_CARROT, function(event) {
                    event.preventDefault();
                    var button = event.target;
                    if (!$(button).hasClass(ClassName.BUTTON)) {
                        button = $(button).closest(Selector.BUTTON);
                    }
                    Button._jQueryInterface.call($(button), "toggle");
                }).on(Event.FOCUS_BLUR_DATA_API, Selector.DATA_TOGGLE_CARROT, function(event) {
                    var button = $(event.target).closest(Selector.BUTTON)[0];
                    $(button).toggleClass(ClassName.FOCUS, /^focus(in)?$/.test(event.type));
                });
                /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */ $.fn[NAME] = Button._jQueryInterface;
                $.fn[NAME].Constructor = Button;
                $.fn[NAME].noConflict = function() {
                    $.fn[NAME] = JQUERY_NO_CONFLICT;
                    return Button._jQueryInterface;
                };
                return Button;
            }(jQuery);
            /**
 * --------------------------------------------------------------------------
 * Bootstrap (v4.0.0-alpha.6): carousel.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */ var Carousel = function($) {
                /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */ var NAME = "carousel";
                var VERSION = "4.0.0-alpha.6";
                var DATA_KEY = "bs.carousel";
                var EVENT_KEY = "." + DATA_KEY;
                var DATA_API_KEY = ".data-api";
                var JQUERY_NO_CONFLICT = $.fn[NAME];
                var TRANSITION_DURATION = 600;
                var ARROW_LEFT_KEYCODE = 37; // KeyboardEvent.which value for left arrow key
                var ARROW_RIGHT_KEYCODE = 39; // KeyboardEvent.which value for right arrow key
                var Default = {
                    interval: 5000,
                    keyboard: true,
                    slide: false,
                    pause: "hover",
                    wrap: true
                };
                var DefaultType = {
                    interval: "(number|boolean)",
                    keyboard: "boolean",
                    slide: "(boolean|string)",
                    pause: "(string|boolean)",
                    wrap: "boolean"
                };
                var Direction = {
                    NEXT: "next",
                    PREV: "prev",
                    LEFT: "left",
                    RIGHT: "right"
                };
                var Event = {
                    SLIDE: "slide" + EVENT_KEY,
                    SLID: "slid" + EVENT_KEY,
                    KEYDOWN: "keydown" + EVENT_KEY,
                    MOUSEENTER: "mouseenter" + EVENT_KEY,
                    MOUSELEAVE: "mouseleave" + EVENT_KEY,
                    LOAD_DATA_API: "load" + EVENT_KEY + DATA_API_KEY,
                    CLICK_DATA_API: "click" + EVENT_KEY + DATA_API_KEY
                };
                var ClassName = {
                    CAROUSEL: "carousel",
                    ACTIVE: "active",
                    SLIDE: "slide",
                    RIGHT: "carousel-item-right",
                    LEFT: "carousel-item-left",
                    NEXT: "carousel-item-next",
                    PREV: "carousel-item-prev",
                    ITEM: "carousel-item"
                };
                var Selector = {
                    ACTIVE: ".active",
                    ACTIVE_ITEM: ".active.carousel-item",
                    ITEM: ".carousel-item",
                    NEXT_PREV: ".carousel-item-next, .carousel-item-prev",
                    INDICATORS: ".carousel-indicators",
                    DATA_SLIDE: "[data-slide], [data-slide-to]",
                    DATA_RIDE: '[data-ride="carousel"]'
                };
                /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */ var Carousel = function() {
                    function Carousel(element, config) {
                        _classCallCheck(this, Carousel);
                        this._items = null;
                        this._interval = null;
                        this._activeElement = null;
                        this._isPaused = false;
                        this._isSliding = false;
                        this._config = this._getConfig(config);
                        this._element = $(element)[0];
                        this._indicatorsElement = $(this._element).find(Selector.INDICATORS)[0];
                        this._addEventListeners();
                    }
                    // getters
                    // public
                    Carousel.prototype.next = function next() {
                        if (this._isSliding) {
                            throw new Error("Carousel is sliding");
                        }
                        this._slide(Direction.NEXT);
                    };
                    Carousel.prototype.nextWhenVisible = function nextWhenVisible() {
                        // Don't call next when the page isn't visible
                        if (!document.hidden) {
                            this.next();
                        }
                    };
                    Carousel.prototype.prev = function prev() {
                        if (this._isSliding) {
                            throw new Error("Carousel is sliding");
                        }
                        this._slide(Direction.PREVIOUS);
                    };
                    Carousel.prototype.pause = function pause(event) {
                        if (!event) {
                            this._isPaused = true;
                        }
                        if ($(this._element).find(Selector.NEXT_PREV)[0] && Util.supportsTransitionEnd()) {
                            Util.triggerTransitionEnd(this._element);
                            this.cycle(true);
                        }
                        clearInterval(this._interval);
                        this._interval = null;
                    };
                    Carousel.prototype.cycle = function cycle(event) {
                        if (!event) {
                            this._isPaused = false;
                        }
                        if (this._interval) {
                            clearInterval(this._interval);
                            this._interval = null;
                        }
                        if (this._config.interval && !this._isPaused) {
                            this._interval = setInterval((document.visibilityState ? this.nextWhenVisible : this.next).bind(this), this._config.interval);
                        }
                    };
                    Carousel.prototype.to = function to(index) {
                        this._activeElement = $(this._element).find(Selector.ACTIVE_ITEM)[0];
                        var activeIndex = this._getItemIndex(this._activeElement);
                        if (index > this._items.length - 1 || index < 0) {
                            return;
                        }
                        if (this._isSliding) {
                            $(this._element).one(Event.SLID, function() {
                                return this.to(index);
                            });
                            return;
                        }
                        if (activeIndex === index) {
                            this.pause();
                            this.cycle();
                            return;
                        }
                        var direction = index > activeIndex ? Direction.NEXT : Direction.PREVIOUS;
                        this._slide(direction, this._items[index]);
                    };
                    Carousel.prototype.dispose = function dispose() {
                        $(this._element).off(EVENT_KEY);
                        $.removeData(this._element, DATA_KEY);
                        this._items = null;
                        this._config = null;
                        this._element = null;
                        this._interval = null;
                        this._isPaused = null;
                        this._isSliding = null;
                        this._activeElement = null;
                        this._indicatorsElement = null;
                    };
                    // private
                    Carousel.prototype._getConfig = function _getConfig(config) {
                        config = $.extend({}, Default, config);
                        Util.typeCheckConfig(NAME, config, DefaultType);
                        return config;
                    };
                    Carousel.prototype._addEventListeners = function _addEventListeners() {
                        if (this._config.keyboard) {
                            $(this._element).on(Event.KEYDOWN, function(event) {
                                return this._keydown(event);
                            });
                        }
                        if (this._config.pause === "hover" && !("ontouchstart" in document.documentElement)) {
                            $(this._element).on(Event.MOUSEENTER, function(event) {
                                return this.pause(event);
                            }).on(Event.MOUSELEAVE, function(event) {
                                return this.cycle(event);
                            });
                        }
                    };
                    Carousel.prototype._keydown = function _keydown(event) {
                        if (/input|textarea/i.test(event.target.tagName)) {
                            return;
                        }
                        switch(event.which){
                            case ARROW_LEFT_KEYCODE:
                                event.preventDefault();
                                this.prev();
                                break;
                            case ARROW_RIGHT_KEYCODE:
                                event.preventDefault();
                                this.next();
                                break;
                            default:
                                return;
                        }
                    };
                    Carousel.prototype._getItemIndex = function _getItemIndex(element) {
                        this._items = $.makeArray($(element).parent().find(Selector.ITEM));
                        return this._items.indexOf(element);
                    };
                    Carousel.prototype._getItemByDirection = function _getItemByDirection(direction, activeElement) {
                        var isNextDirection = direction === Direction.NEXT;
                        var isPrevDirection = direction === Direction.PREVIOUS;
                        var activeIndex = this._getItemIndex(activeElement);
                        var lastItemIndex = this._items.length - 1;
                        var isGoingToWrap = isPrevDirection && activeIndex === 0 || isNextDirection && activeIndex === lastItemIndex;
                        if (isGoingToWrap && !this._config.wrap) {
                            return activeElement;
                        }
                        var delta = direction === Direction.PREVIOUS ? -1 : 1;
                        var itemIndex = (activeIndex + delta) % this._items.length;
                        return itemIndex === -1 ? this._items[this._items.length - 1] : this._items[itemIndex];
                    };
                    Carousel.prototype._triggerSlideEvent = function _triggerSlideEvent(relatedTarget, eventDirectionName) {
                        var slideEvent = $.Event(Event.SLIDE, {
                            relatedTarget: relatedTarget,
                            direction: eventDirectionName
                        });
                        $(this._element).trigger(slideEvent);
                        return slideEvent;
                    };
                    Carousel.prototype._setActiveIndicatorElement = function _setActiveIndicatorElement(element) {
                        if (this._indicatorsElement) {
                            $(this._indicatorsElement).find(Selector.ACTIVE).removeClass(ClassName.ACTIVE);
                            var nextIndicator = this._indicatorsElement.children[this._getItemIndex(element)];
                            if (nextIndicator) {
                                $(nextIndicator).addClass(ClassName.ACTIVE);
                            }
                        }
                    };
                    Carousel.prototype._slide = function _slide(direction, element) {
                        var activeElement = $(this._element).find(Selector.ACTIVE_ITEM)[0];
                        var nextElement = element || activeElement && this._getItemByDirection(direction, activeElement);
                        var isCycling = Boolean(this._interval);
                        var directionalClassName = void 0;
                        var orderClassName = void 0;
                        var eventDirectionName = void 0;
                        if (direction === Direction.NEXT) {
                            directionalClassName = ClassName.LEFT;
                            orderClassName = ClassName.NEXT;
                            eventDirectionName = Direction.LEFT;
                        } else {
                            directionalClassName = ClassName.RIGHT;
                            orderClassName = ClassName.PREV;
                            eventDirectionName = Direction.RIGHT;
                        }
                        if (nextElement && $(nextElement).hasClass(ClassName.ACTIVE)) {
                            this._isSliding = false;
                            return;
                        }
                        var slideEvent = this._triggerSlideEvent(nextElement, eventDirectionName);
                        if (slideEvent.isDefaultPrevented()) {
                            return;
                        }
                        if (!activeElement || !nextElement) {
                            // some weirdness is happening, so we bail
                            return;
                        }
                        this._isSliding = true;
                        if (isCycling) {
                            this.pause();
                        }
                        this._setActiveIndicatorElement(nextElement);
                        var slidEvent = $.Event(Event.SLID, {
                            relatedTarget: nextElement,
                            direction: eventDirectionName
                        });
                        if (Util.supportsTransitionEnd() && $(this._element).hasClass(ClassName.SLIDE)) {
                            $(nextElement).addClass(orderClassName);
                            Util.reflow(nextElement);
                            $(activeElement).addClass(directionalClassName);
                            $(nextElement).addClass(directionalClassName);
                            $(activeElement).one(Util.TRANSITION_END, function() {
                                $(nextElement).removeClass(directionalClassName + " " + orderClassName).addClass(ClassName.ACTIVE);
                                $(activeElement).removeClass(ClassName.ACTIVE + " " + orderClassName + " " + directionalClassName);
                                this._isSliding = false;
                                setTimeout(function() {
                                    return $(this._element).trigger(slidEvent);
                                }, 0);
                            }).emulateTransitionEnd(TRANSITION_DURATION);
                        } else {
                            $(activeElement).removeClass(ClassName.ACTIVE);
                            $(nextElement).addClass(ClassName.ACTIVE);
                            this._isSliding = false;
                            $(this._element).trigger(slidEvent);
                        }
                        if (isCycling) {
                            this.cycle();
                        }
                    };
                    // static
                    Carousel._jQueryInterface = function _jQueryInterface(config) {
                        return this.each(function() {
                            var data = $(this).data(DATA_KEY);
                            var _config = $.extend({}, Default, $(this).data());
                            if ((typeof config === "undefined" ? "undefined" : _typeof(config)) === "object") {
                                $.extend(_config, config);
                            }
                            var action = typeof config === "string" ? config : _config.slide;
                            if (!data) {
                                data = new Carousel(this, _config);
                                $(this).data(DATA_KEY, data);
                            }
                            if (typeof config === "number") {
                                data.to(config);
                            } else if (typeof action === "string") {
                                if (data[action] === undefined) {
                                    throw new Error('No method named "' + action + '"');
                                }
                                data[action]();
                            } else if (_config.interval) {
                                data.pause();
                                data.cycle();
                            }
                        });
                    };
                    Carousel._dataApiClickHandler = function _dataApiClickHandler(event) {
                        var selector = Util.getSelectorFromElement(this);
                        if (!selector) {
                            return;
                        }
                        var target = $(selector)[0];
                        if (!target || !$(target).hasClass(ClassName.CAROUSEL)) {
                            return;
                        }
                        var config = $.extend({}, $(target).data(), $(this).data());
                        var slideIndex = this.getAttribute("data-slide-to");
                        if (slideIndex) {
                            config.interval = false;
                        }
                        Carousel._jQueryInterface.call($(target), config);
                        if (slideIndex) {
                            $(target).data(DATA_KEY).to(slideIndex);
                        }
                        event.preventDefault();
                    };
                    _createClass(Carousel, null, [
                        {
                            key: "VERSION",
                            get: function get() {
                                return VERSION;
                            }
                        },
                        {
                            key: "Default",
                            get: function get() {
                                return Default;
                            }
                        }
                    ]);
                    return Carousel;
                }();
                /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */ $(document).on(Event.CLICK_DATA_API, Selector.DATA_SLIDE, Carousel._dataApiClickHandler);
                $(window).on(Event.LOAD_DATA_API, function() {
                    $(Selector.DATA_RIDE).each(function() {
                        var $carousel = $(this);
                        Carousel._jQueryInterface.call($carousel, $carousel.data());
                    });
                });
                /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */ $.fn[NAME] = Carousel._jQueryInterface;
                $.fn[NAME].Constructor = Carousel;
                $.fn[NAME].noConflict = function() {
                    $.fn[NAME] = JQUERY_NO_CONFLICT;
                    return Carousel._jQueryInterface;
                };
                return Carousel;
            }(jQuery);
            /**
 * --------------------------------------------------------------------------
 * Bootstrap (v4.0.0-alpha.6): collapse.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */ var Collapse = function($) {
                /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */ var NAME = "collapse";
                var VERSION = "4.0.0-alpha.6";
                var DATA_KEY = "bs.collapse";
                var EVENT_KEY = "." + DATA_KEY;
                var DATA_API_KEY = ".data-api";
                var JQUERY_NO_CONFLICT = $.fn[NAME];
                var TRANSITION_DURATION = 600;
                var Default = {
                    toggle: true,
                    parent: ""
                };
                var DefaultType = {
                    toggle: "boolean",
                    parent: "string"
                };
                var Event = {
                    SHOW: "show" + EVENT_KEY,
                    SHOWN: "shown" + EVENT_KEY,
                    HIDE: "hide" + EVENT_KEY,
                    HIDDEN: "hidden" + EVENT_KEY,
                    CLICK_DATA_API: "click" + EVENT_KEY + DATA_API_KEY
                };
                var ClassName = {
                    SHOW: "show",
                    COLLAPSE: "collapse",
                    COLLAPSING: "collapsing",
                    COLLAPSED: "collapsed"
                };
                var Dimension = {
                    WIDTH: "width",
                    HEIGHT: "height"
                };
                var Selector = {
                    ACTIVES: ".card > .show, .card > .collapsing",
                    DATA_TOGGLE: '[data-toggle="collapse"]'
                };
                /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */ var Collapse = function() {
                    function Collapse(element, config) {
                        _classCallCheck(this, Collapse);
                        this._isTransitioning = false;
                        this._element = element;
                        this._config = this._getConfig(config);
                        this._triggerArray = $.makeArray($('[data-toggle="collapse"][href="#' + element.id + '"],' + ('[data-toggle="collapse"][data-target="#' + element.id + '"]')));
                        this._parent = this._config.parent ? this._getParent() : null;
                        if (!this._config.parent) {
                            this._addAriaAndCollapsedClass(this._element, this._triggerArray);
                        }
                        if (this._config.toggle) {
                            this.toggle();
                        }
                    }
                    // getters
                    // public
                    Collapse.prototype.toggle = function toggle() {
                        if ($(this._element).hasClass(ClassName.SHOW)) {
                            this.hide();
                        } else {
                            this.show();
                        }
                    };
                    Collapse.prototype.show = function show() {
                        if (this._isTransitioning) {
                            throw new Error("Collapse is transitioning");
                        }
                        if ($(this._element).hasClass(ClassName.SHOW)) {
                            return;
                        }
                        var actives = void 0;
                        var activesData = void 0;
                        if (this._parent) {
                            actives = $.makeArray($(this._parent).find(Selector.ACTIVES));
                            if (!actives.length) {
                                actives = null;
                            }
                        }
                        if (actives) {
                            activesData = $(actives).data(DATA_KEY);
                            if (activesData && activesData._isTransitioning) {
                                return;
                            }
                        }
                        var startEvent = $.Event(Event.SHOW);
                        $(this._element).trigger(startEvent);
                        if (startEvent.isDefaultPrevented()) {
                            return;
                        }
                        if (actives) {
                            Collapse._jQueryInterface.call($(actives), "hide");
                            if (!activesData) {
                                $(actives).data(DATA_KEY, null);
                            }
                        }
                        var dimension = this._getDimension();
                        $(this._element).removeClass(ClassName.COLLAPSE).addClass(ClassName.COLLAPSING);
                        this._element.style[dimension] = 0;
                        this._element.setAttribute("aria-expanded", true);
                        if (this._triggerArray.length) {
                            $(this._triggerArray).removeClass(ClassName.COLLAPSED).attr("aria-expanded", true);
                        }
                        this.setTransitioning(true);
                        var complete = function complete() {
                            $(this._element).removeClass(ClassName.COLLAPSING).addClass(ClassName.COLLAPSE).addClass(ClassName.SHOW);
                            this._element.style[dimension] = "";
                            this.setTransitioning(false);
                            $(this._element).trigger(Event.SHOWN);
                        };
                        if (!Util.supportsTransitionEnd()) {
                            complete();
                            return;
                        }
                        var capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
                        var scrollSize = "scroll" + capitalizedDimension;
                        $(this._element).one(Util.TRANSITION_END, complete).emulateTransitionEnd(TRANSITION_DURATION);
                        this._element.style[dimension] = this._element[scrollSize] + "px";
                    };
                    Collapse.prototype.hide = function hide() {
                        if (this._isTransitioning) {
                            throw new Error("Collapse is transitioning");
                        }
                        if (!$(this._element).hasClass(ClassName.SHOW)) {
                            return;
                        }
                        var startEvent = $.Event(Event.HIDE);
                        $(this._element).trigger(startEvent);
                        if (startEvent.isDefaultPrevented()) {
                            return;
                        }
                        var dimension = this._getDimension();
                        var offsetDimension = dimension === Dimension.WIDTH ? "offsetWidth" : "offsetHeight";
                        this._element.style[dimension] = this._element[offsetDimension] + "px";
                        Util.reflow(this._element);
                        $(this._element).addClass(ClassName.COLLAPSING).removeClass(ClassName.COLLAPSE).removeClass(ClassName.SHOW);
                        this._element.setAttribute("aria-expanded", false);
                        if (this._triggerArray.length) {
                            $(this._triggerArray).addClass(ClassName.COLLAPSED).attr("aria-expanded", false);
                        }
                        this.setTransitioning(true);
                        var complete = function complete() {
                            this.setTransitioning(false);
                            $(this._element).removeClass(ClassName.COLLAPSING).addClass(ClassName.COLLAPSE).trigger(Event.HIDDEN);
                        };
                        this._element.style[dimension] = "";
                        if (!Util.supportsTransitionEnd()) {
                            complete();
                            return;
                        }
                        $(this._element).one(Util.TRANSITION_END, complete).emulateTransitionEnd(TRANSITION_DURATION);
                    };
                    Collapse.prototype.setTransitioning = function setTransitioning(isTransitioning) {
                        this._isTransitioning = isTransitioning;
                    };
                    Collapse.prototype.dispose = function dispose() {
                        $.removeData(this._element, DATA_KEY);
                        this._config = null;
                        this._parent = null;
                        this._element = null;
                        this._triggerArray = null;
                        this._isTransitioning = null;
                    };
                    // private
                    Collapse.prototype._getConfig = function _getConfig(config) {
                        config = $.extend({}, Default, config);
                        config.toggle = Boolean(config.toggle); // coerce string values
                        Util.typeCheckConfig(NAME, config, DefaultType);
                        return config;
                    };
                    Collapse.prototype._getDimension = function _getDimension() {
                        var hasWidth = $(this._element).hasClass(Dimension.WIDTH);
                        return hasWidth ? Dimension.WIDTH : Dimension.HEIGHT;
                    };
                    Collapse.prototype._getParent = function _getParent() {
                        var parent = $(this._config.parent)[0];
                        var selector = '[data-toggle="collapse"][data-parent="' + this._config.parent + '"]';
                        $(parent).find(selector).each(function(i, element) {
                            this._addAriaAndCollapsedClass(Collapse._getTargetFromElement(element), [
                                element
                            ]);
                        });
                        return parent;
                    };
                    Collapse.prototype._addAriaAndCollapsedClass = function _addAriaAndCollapsedClass(element, triggerArray) {
                        if (element) {
                            var isOpen = $(element).hasClass(ClassName.SHOW);
                            element.setAttribute("aria-expanded", isOpen);
                            if (triggerArray.length) {
                                $(triggerArray).toggleClass(ClassName.COLLAPSED, !isOpen).attr("aria-expanded", isOpen);
                            }
                        }
                    };
                    // static
                    Collapse._getTargetFromElement = function _getTargetFromElement(element) {
                        var selector = Util.getSelectorFromElement(element);
                        return selector ? $(selector)[0] : null;
                    };
                    Collapse._jQueryInterface = function _jQueryInterface(config) {
                        return this.each(function() {
                            var $this = $(this);
                            var data = $this.data(DATA_KEY);
                            var _config = $.extend({}, Default, $this.data(), (typeof config === "undefined" ? "undefined" : _typeof(config)) === "object" && config);
                            if (!data && _config.toggle && /show|hide/.test(config)) {
                                _config.toggle = false;
                            }
                            if (!data) {
                                data = new Collapse(this, _config);
                                $this.data(DATA_KEY, data);
                            }
                            if (typeof config === "string") {
                                if (data[config] === undefined) {
                                    throw new Error('No method named "' + config + '"');
                                }
                                data[config]();
                            }
                        });
                    };
                    _createClass(Collapse, null, [
                        {
                            key: "VERSION",
                            get: function get() {
                                return VERSION;
                            }
                        },
                        {
                            key: "Default",
                            get: function get() {
                                return Default;
                            }
                        }
                    ]);
                    return Collapse;
                }();
                /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */ $(document).on(Event.CLICK_DATA_API, Selector.DATA_TOGGLE, function(event) {
                    event.preventDefault();
                    var target = Collapse._getTargetFromElement(this);
                    var data = $(target).data(DATA_KEY);
                    var config = data ? "toggle" : $(this).data();
                    Collapse._jQueryInterface.call($(target), config);
                });
                /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */ $.fn[NAME] = Collapse._jQueryInterface;
                $.fn[NAME].Constructor = Collapse;
                $.fn[NAME].noConflict = function() {
                    $.fn[NAME] = JQUERY_NO_CONFLICT;
                    return Collapse._jQueryInterface;
                };
                return Collapse;
            }(jQuery);
            /**
 * --------------------------------------------------------------------------
 * Bootstrap (v4.0.0-alpha.6): dropdown.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */ var Dropdown = function($) {
                /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */ var NAME = "dropdown";
                var VERSION = "4.0.0-alpha.6";
                var DATA_KEY = "bs.dropdown";
                var EVENT_KEY = "." + DATA_KEY;
                var DATA_API_KEY = ".data-api";
                var JQUERY_NO_CONFLICT = $.fn[NAME];
                var ESCAPE_KEYCODE = 27; // KeyboardEvent.which value for Escape (Esc) key
                var ARROW_UP_KEYCODE = 38; // KeyboardEvent.which value for up arrow key
                var ARROW_DOWN_KEYCODE = 40; // KeyboardEvent.which value for down arrow key
                var RIGHT_MOUSE_BUTTON_WHICH = 3; // MouseEvent.which value for the right button (assuming a right-handed mouse)
                var Event = {
                    HIDE: "hide" + EVENT_KEY,
                    HIDDEN: "hidden" + EVENT_KEY,
                    SHOW: "show" + EVENT_KEY,
                    SHOWN: "shown" + EVENT_KEY,
                    CLICK: "click" + EVENT_KEY,
                    CLICK_DATA_API: "click" + EVENT_KEY + DATA_API_KEY,
                    FOCUSIN_DATA_API: "focusin" + EVENT_KEY + DATA_API_KEY,
                    KEYDOWN_DATA_API: "keydown" + EVENT_KEY + DATA_API_KEY
                };
                var ClassName = {
                    BACKDROP: "dropdown-backdrop",
                    DISABLED: "disabled",
                    SHOW: "show"
                };
                var Selector = {
                    BACKDROP: ".dropdown-backdrop",
                    DATA_TOGGLE: '[data-toggle="dropdown"]',
                    FORM_CHILD: ".dropdown form",
                    ROLE_MENU: '[role="menu"]',
                    ROLE_LISTBOX: '[role="listbox"]',
                    NAVBAR_NAV: ".navbar-nav",
                    VISIBLE_ITEMS: '[role="menu"] li:not(.disabled) a, ' + '[role="listbox"] li:not(.disabled) a'
                };
                /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */ var Dropdown = function() {
                    function Dropdown(element) {
                        _classCallCheck(this, Dropdown);
                        this._element = element;
                        this._addEventListeners();
                    }
                    // getters
                    // public
                    Dropdown.prototype.toggle = function toggle() {
                        if (this.disabled || $(this).hasClass(ClassName.DISABLED)) {
                            return false;
                        }
                        var parent = Dropdown._getParentFromElement(this);
                        var isActive = $(parent).hasClass(ClassName.SHOW);
                        Dropdown._clearMenus();
                        if (isActive) {
                            return false;
                        }
                        if ("ontouchstart" in document.documentElement && !$(parent).closest(Selector.NAVBAR_NAV).length) {
                            // if mobile we use a backdrop because click events don't delegate
                            var dropdown = document.createElement("div");
                            dropdown.className = ClassName.BACKDROP;
                            $(dropdown).insertBefore(this);
                            $(dropdown).on("click", Dropdown._clearMenus);
                        }
                        var relatedTarget = {
                            relatedTarget: this
                        };
                        var showEvent = $.Event(Event.SHOW, relatedTarget);
                        $(parent).trigger(showEvent);
                        if (showEvent.isDefaultPrevented()) {
                            return false;
                        }
                        this.focus();
                        this.setAttribute("aria-expanded", true);
                        $(parent).toggleClass(ClassName.SHOW);
                        $(parent).trigger($.Event(Event.SHOWN, relatedTarget));
                        return false;
                    };
                    Dropdown.prototype.dispose = function dispose() {
                        $.removeData(this._element, DATA_KEY);
                        $(this._element).off(EVENT_KEY);
                        this._element = null;
                    };
                    // private
                    Dropdown.prototype._addEventListeners = function _addEventListeners() {
                        $(this._element).on(Event.CLICK, this.toggle);
                    };
                    // static
                    Dropdown._jQueryInterface = function _jQueryInterface(config) {
                        return this.each(function() {
                            var data = $(this).data(DATA_KEY);
                            if (!data) {
                                data = new Dropdown(this);
                                $(this).data(DATA_KEY, data);
                            }
                            if (typeof config === "string") {
                                if (data[config] === undefined) {
                                    throw new Error('No method named "' + config + '"');
                                }
                                data[config].call(this);
                            }
                        });
                    };
                    Dropdown._clearMenus = function _clearMenus(event) {
                        if (event && event.which === RIGHT_MOUSE_BUTTON_WHICH) {
                            return;
                        }
                        var backdrop = $(Selector.BACKDROP)[0];
                        if (backdrop) {
                            backdrop.parentNode.removeChild(backdrop);
                        }
                        var toggles = $.makeArray($(Selector.DATA_TOGGLE));
                        for(var i = 0; i < toggles.length; i++){
                            var parent = Dropdown._getParentFromElement(toggles[i]);
                            var relatedTarget = {
                                relatedTarget: toggles[i]
                            };
                            if (!$(parent).hasClass(ClassName.SHOW)) {
                                continue;
                            }
                            if (event && (event.type === "click" && /input|textarea/i.test(event.target.tagName) || event.type === "focusin") && $.contains(parent, event.target)) {
                                continue;
                            }
                            var hideEvent = $.Event(Event.HIDE, relatedTarget);
                            $(parent).trigger(hideEvent);
                            if (hideEvent.isDefaultPrevented()) {
                                continue;
                            }
                            toggles[i].setAttribute("aria-expanded", "false");
                            $(parent).removeClass(ClassName.SHOW).trigger($.Event(Event.HIDDEN, relatedTarget));
                        }
                    };
                    Dropdown._getParentFromElement = function _getParentFromElement(element) {
                        var parent = void 0;
                        var selector = Util.getSelectorFromElement(element);
                        if (selector) {
                            parent = $(selector)[0];
                        }
                        return parent || element.parentNode;
                    };
                    Dropdown._dataApiKeydownHandler = function _dataApiKeydownHandler(event) {
                        if (!/(38|40|27|32)/.test(event.which) || /input|textarea/i.test(event.target.tagName)) {
                            return;
                        }
                        event.preventDefault();
                        event.stopPropagation();
                        if (this.disabled || $(this).hasClass(ClassName.DISABLED)) {
                            return;
                        }
                        var parent = Dropdown._getParentFromElement(this);
                        var isActive = $(parent).hasClass(ClassName.SHOW);
                        if (!isActive && event.which !== ESCAPE_KEYCODE || isActive && event.which === ESCAPE_KEYCODE) {
                            if (event.which === ESCAPE_KEYCODE) {
                                var toggle = $(parent).find(Selector.DATA_TOGGLE)[0];
                                $(toggle).trigger("focus");
                            }
                            $(this).trigger("click");
                            return;
                        }
                        var items = $(parent).find(Selector.VISIBLE_ITEMS).get();
                        if (!items.length) {
                            return;
                        }
                        var index = items.indexOf(event.target);
                        if (event.which === ARROW_UP_KEYCODE && index > 0) {
                            // up
                            index--;
                        }
                        if (event.which === ARROW_DOWN_KEYCODE && index < items.length - 1) {
                            // down
                            index++;
                        }
                        if (index < 0) {
                            index = 0;
                        }
                        items[index].focus();
                    };
                    _createClass(Dropdown, null, [
                        {
                            key: "VERSION",
                            get: function get() {
                                return VERSION;
                            }
                        }
                    ]);
                    return Dropdown;
                }();
                /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */ $(document).on(Event.KEYDOWN_DATA_API, Selector.DATA_TOGGLE, Dropdown._dataApiKeydownHandler).on(Event.KEYDOWN_DATA_API, Selector.ROLE_MENU, Dropdown._dataApiKeydownHandler).on(Event.KEYDOWN_DATA_API, Selector.ROLE_LISTBOX, Dropdown._dataApiKeydownHandler).on(Event.CLICK_DATA_API + " " + Event.FOCUSIN_DATA_API, Dropdown._clearMenus).on(Event.CLICK_DATA_API, Selector.DATA_TOGGLE, Dropdown.prototype.toggle).on(Event.CLICK_DATA_API, Selector.FORM_CHILD, function(e) {
                    e.stopPropagation();
                });
                /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */ $.fn[NAME] = Dropdown._jQueryInterface;
                $.fn[NAME].Constructor = Dropdown;
                $.fn[NAME].noConflict = function() {
                    $.fn[NAME] = JQUERY_NO_CONFLICT;
                    return Dropdown._jQueryInterface;
                };
                return Dropdown;
            }(jQuery);
            /**
 * --------------------------------------------------------------------------
 * Bootstrap (v4.0.0-alpha.6): modal.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */ var Modal = function($) {
                /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */ var NAME = "modal";
                var VERSION = "4.0.0-alpha.6";
                var DATA_KEY = "bs.modal";
                var EVENT_KEY = "." + DATA_KEY;
                var DATA_API_KEY = ".data-api";
                var JQUERY_NO_CONFLICT = $.fn[NAME];
                var TRANSITION_DURATION = 300;
                var BACKDROP_TRANSITION_DURATION = 150;
                var ESCAPE_KEYCODE = 27; // KeyboardEvent.which value for Escape (Esc) key
                var Default = {
                    backdrop: true,
                    keyboard: true,
                    focus: true,
                    show: true
                };
                var DefaultType = {
                    backdrop: "(boolean|string)",
                    keyboard: "boolean",
                    focus: "boolean",
                    show: "boolean"
                };
                var Event = {
                    HIDE: "hide" + EVENT_KEY,
                    HIDDEN: "hidden" + EVENT_KEY,
                    SHOW: "show" + EVENT_KEY,
                    SHOWN: "shown" + EVENT_KEY,
                    FOCUSIN: "focusin" + EVENT_KEY,
                    RESIZE: "resize" + EVENT_KEY,
                    CLICK_DISMISS: "click.dismiss" + EVENT_KEY,
                    KEYDOWN_DISMISS: "keydown.dismiss" + EVENT_KEY,
                    MOUSEUP_DISMISS: "mouseup.dismiss" + EVENT_KEY,
                    MOUSEDOWN_DISMISS: "mousedown.dismiss" + EVENT_KEY,
                    CLICK_DATA_API: "click" + EVENT_KEY + DATA_API_KEY
                };
                var ClassName = {
                    SCROLLBAR_MEASURER: "modal-scrollbar-measure",
                    BACKDROP: "modal-backdrop",
                    OPEN: "modal-open",
                    FADE: "fade",
                    SHOW: "show"
                };
                var Selector = {
                    DIALOG: ".modal-dialog",
                    DATA_TOGGLE: '[data-toggle="modal"]',
                    DATA_DISMISS: '[data-dismiss="modal"]',
                    FIXED_CONTENT: ".fixed-top, .fixed-bottom, .is-fixed, .sticky-top"
                };
                /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */ var Modal = function() {
                    function Modal(element, config) {
                        _classCallCheck(this, Modal);
                        this._config = this._getConfig(config);
                        this._element = element;
                        this._dialog = $(element).find(Selector.DIALOG)[0];
                        this._backdrop = null;
                        this._isShown = false;
                        this._isBodyOverflowing = false;
                        this._ignoreBackdropClick = false;
                        this._isTransitioning = false;
                        this._originalBodyPadding = 0;
                        this._scrollbarWidth = 0;
                    }
                    // getters
                    // public
                    Modal.prototype.toggle = function toggle(relatedTarget) {
                        return this._isShown ? this.hide() : this.show(relatedTarget);
                    };
                    Modal.prototype.show = function show(relatedTarget) {
                        if (this._isTransitioning) {
                            throw new Error("Modal is transitioning");
                        }
                        if (Util.supportsTransitionEnd() && $(this._element).hasClass(ClassName.FADE)) {
                            this._isTransitioning = true;
                        }
                        var showEvent = $.Event(Event.SHOW, {
                            relatedTarget: relatedTarget
                        });
                        $(this._element).trigger(showEvent);
                        if (this._isShown || showEvent.isDefaultPrevented()) {
                            return;
                        }
                        this._isShown = true;
                        this._checkScrollbar();
                        this._setScrollbar();
                        $(document.body).addClass(ClassName.OPEN);
                        this._setEscapeEvent();
                        this._setResizeEvent();
                        $(this._element).on(Event.CLICK_DISMISS, Selector.DATA_DISMISS, function(event) {
                            return this.hide(event);
                        });
                        $(this._dialog).on(Event.MOUSEDOWN_DISMISS, function() {
                            $(this._element).one(Event.MOUSEUP_DISMISS, function(event) {
                                if ($(event.target).is(this._element)) {
                                    this._ignoreBackdropClick = true;
                                }
                            });
                        });
                        this._showBackdrop(function() {
                            return this._showElement(relatedTarget);
                        });
                    };
                    Modal.prototype.hide = function hide(event) {
                        if (event) {
                            event.preventDefault();
                        }
                        if (this._isTransitioning) {
                            throw new Error("Modal is transitioning");
                        }
                        var transition = Util.supportsTransitionEnd() && $(this._element).hasClass(ClassName.FADE);
                        if (transition) {
                            this._isTransitioning = true;
                        }
                        var hideEvent = $.Event(Event.HIDE);
                        $(this._element).trigger(hideEvent);
                        if (!this._isShown || hideEvent.isDefaultPrevented()) {
                            return;
                        }
                        this._isShown = false;
                        this._setEscapeEvent();
                        this._setResizeEvent();
                        $(document).off(Event.FOCUSIN);
                        $(this._element).removeClass(ClassName.SHOW);
                        $(this._element).off(Event.CLICK_DISMISS);
                        $(this._dialog).off(Event.MOUSEDOWN_DISMISS);
                        if (transition) {
                            $(this._element).one(Util.TRANSITION_END, function(event) {
                                return this._hideModal(event);
                            }).emulateTransitionEnd(TRANSITION_DURATION);
                        } else {
                            this._hideModal();
                        }
                    };
                    Modal.prototype.dispose = function dispose() {
                        $.removeData(this._element, DATA_KEY);
                        $(window, document, this._element, this._backdrop).off(EVENT_KEY);
                        this._config = null;
                        this._element = null;
                        this._dialog = null;
                        this._backdrop = null;
                        this._isShown = null;
                        this._isBodyOverflowing = null;
                        this._ignoreBackdropClick = null;
                        this._originalBodyPadding = null;
                        this._scrollbarWidth = null;
                    };
                    // private
                    Modal.prototype._getConfig = function _getConfig(config) {
                        config = $.extend({}, Default, config);
                        Util.typeCheckConfig(NAME, config, DefaultType);
                        return config;
                    };
                    Modal.prototype._showElement = function _showElement(relatedTarget) {
                        var transition = Util.supportsTransitionEnd() && $(this._element).hasClass(ClassName.FADE);
                        if (!this._element.parentNode || this._element.parentNode.nodeType !== Node.ELEMENT_NODE) {
                            // don't move modals dom position
                            document.body.appendChild(this._element);
                        }
                        this._element.style.display = "block";
                        this._element.removeAttribute("aria-hidden");
                        this._element.scrollTop = 0;
                        if (transition) {
                            Util.reflow(this._element);
                        }
                        $(this._element).addClass(ClassName.SHOW);
                        if (this._config.focus) {
                            this._enforceFocus();
                        }
                        var shownEvent = $.Event(Event.SHOWN, {
                            relatedTarget: relatedTarget
                        });
                        var transitionComplete = function transitionComplete() {
                            if (this._config.focus) {
                                this._element.focus();
                            }
                            this._isTransitioning = false;
                            $(this._element).trigger(shownEvent);
                        };
                        if (transition) {
                            $(this._dialog).one(Util.TRANSITION_END, transitionComplete).emulateTransitionEnd(TRANSITION_DURATION);
                        } else {
                            transitionComplete();
                        }
                    };
                    Modal.prototype._enforceFocus = function _enforceFocus() {
                        $(document).off(Event.FOCUSIN) // guard against infinite focus loop
                        .on(Event.FOCUSIN, function(event) {
                            if (document !== event.target && this._element !== event.target && !$(this._element).has(event.target).length) {
                                this._element.focus();
                            }
                        });
                    };
                    Modal.prototype._setEscapeEvent = function _setEscapeEvent() {
                        if (this._isShown && this._config.keyboard) {
                            $(this._element).on(Event.KEYDOWN_DISMISS, function(event) {
                                if (event.which === ESCAPE_KEYCODE) {
                                    this.hide();
                                }
                            });
                        } else if (!this._isShown) {
                            $(this._element).off(Event.KEYDOWN_DISMISS);
                        }
                    };
                    Modal.prototype._setResizeEvent = function _setResizeEvent() {
                        if (this._isShown) {
                            $(window).on(Event.RESIZE, function(event) {
                                return this._handleUpdate(event);
                            });
                        } else {
                            $(window).off(Event.RESIZE);
                        }
                    };
                    Modal.prototype._hideModal = function _hideModal() {
                        this._element.style.display = "none";
                        this._element.setAttribute("aria-hidden", "true");
                        this._isTransitioning = false;
                        this._showBackdrop(function() {
                            $(document.body).removeClass(ClassName.OPEN);
                            this._resetAdjustments();
                            this._resetScrollbar();
                            $(this._element).trigger(Event.HIDDEN);
                        });
                    };
                    Modal.prototype._removeBackdrop = function _removeBackdrop() {
                        if (this._backdrop) {
                            $(this._backdrop).remove();
                            this._backdrop = null;
                        }
                    };
                    Modal.prototype._showBackdrop = function _showBackdrop(callback) {
                        var animate = $(this._element).hasClass(ClassName.FADE) ? ClassName.FADE : "";
                        if (this._isShown && this._config.backdrop) {
                            var doAnimate = Util.supportsTransitionEnd() && animate;
                            this._backdrop = document.createElement("div");
                            this._backdrop.className = ClassName.BACKDROP;
                            if (animate) {
                                $(this._backdrop).addClass(animate);
                            }
                            $(this._backdrop).appendTo(document.body);
                            $(this._element).on(Event.CLICK_DISMISS, function(event) {
                                if (this._ignoreBackdropClick) {
                                    this._ignoreBackdropClick = false;
                                    return;
                                }
                                if (event.target !== event.currentTarget) {
                                    return;
                                }
                                if (this._config.backdrop === "static") {
                                    this._element.focus();
                                } else {
                                    this.hide();
                                }
                            });
                            if (doAnimate) {
                                Util.reflow(this._backdrop);
                            }
                            $(this._backdrop).addClass(ClassName.SHOW);
                            if (!callback) {
                                return;
                            }
                            if (!doAnimate) {
                                callback();
                                return;
                            }
                            $(this._backdrop).one(Util.TRANSITION_END, callback).emulateTransitionEnd(BACKDROP_TRANSITION_DURATION);
                        } else if (!this._isShown && this._backdrop) {
                            $(this._backdrop).removeClass(ClassName.SHOW);
                            var callbackRemove = function callbackRemove() {
                                this._removeBackdrop();
                                if (callback) {
                                    callback();
                                }
                            };
                            if (Util.supportsTransitionEnd() && $(this._element).hasClass(ClassName.FADE)) {
                                $(this._backdrop).one(Util.TRANSITION_END, callbackRemove).emulateTransitionEnd(BACKDROP_TRANSITION_DURATION);
                            } else {
                                callbackRemove();
                            }
                        } else if (callback) {
                            callback();
                        }
                    };
                    // ----------------------------------------------------------------------
                    // the following methods are used to handle overflowing modals
                    // todo (fat): these should probably be refactored out of modal.js
                    // ----------------------------------------------------------------------
                    Modal.prototype._handleUpdate = function _handleUpdate() {
                        this._adjustDialog();
                    };
                    Modal.prototype._adjustDialog = function _adjustDialog() {
                        var isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
                        if (!this._isBodyOverflowing && isModalOverflowing) {
                            this._element.style.paddingLeft = this._scrollbarWidth + "px";
                        }
                        if (this._isBodyOverflowing && !isModalOverflowing) {
                            this._element.style.paddingRight = this._scrollbarWidth + "px";
                        }
                    };
                    Modal.prototype._resetAdjustments = function _resetAdjustments() {
                        this._element.style.paddingLeft = "";
                        this._element.style.paddingRight = "";
                    };
                    Modal.prototype._checkScrollbar = function _checkScrollbar() {
                        this._isBodyOverflowing = document.body.clientWidth < window.innerWidth;
                        this._scrollbarWidth = this._getScrollbarWidth();
                    };
                    Modal.prototype._setScrollbar = function _setScrollbar() {
                        var bodyPadding = parseInt($(Selector.FIXED_CONTENT).css("padding-right") || 0, 10);
                        this._originalBodyPadding = document.body.style.paddingRight || "";
                        if (this._isBodyOverflowing) {
                            document.body.style.paddingRight = bodyPadding + this._scrollbarWidth + "px";
                        }
                    };
                    Modal.prototype._resetScrollbar = function _resetScrollbar() {
                        document.body.style.paddingRight = this._originalBodyPadding;
                    };
                    Modal.prototype._getScrollbarWidth = function _getScrollbarWidth() {
                        // thx d.walsh
                        var scrollDiv = document.createElement("div");
                        scrollDiv.className = ClassName.SCROLLBAR_MEASURER;
                        document.body.appendChild(scrollDiv);
                        var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
                        document.body.removeChild(scrollDiv);
                        return scrollbarWidth;
                    };
                    // static
                    Modal._jQueryInterface = function _jQueryInterface(config, relatedTarget) {
                        return this.each(function() {
                            var data = $(this).data(DATA_KEY);
                            var _config = $.extend({}, Modal.Default, $(this).data(), (typeof config === "undefined" ? "undefined" : _typeof(config)) === "object" && config);
                            if (!data) {
                                data = new Modal(this, _config);
                                $(this).data(DATA_KEY, data);
                            }
                            if (typeof config === "string") {
                                if (data[config] === undefined) {
                                    throw new Error('No method named "' + config + '"');
                                }
                                data[config](relatedTarget);
                            } else if (_config.show) {
                                data.show(relatedTarget);
                            }
                        });
                    };
                    _createClass(Modal, null, [
                        {
                            key: "VERSION",
                            get: function get() {
                                return VERSION;
                            }
                        },
                        {
                            key: "Default",
                            get: function get() {
                                return Default;
                            }
                        }
                    ]);
                    return Modal;
                }();
                /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */ $(document).on(Event.CLICK_DATA_API, Selector.DATA_TOGGLE, function(event) {
                    var target = void 0;
                    var selector = Util.getSelectorFromElement(this);
                    if (selector) {
                        target = $(selector)[0];
                    }
                    var config = $(target).data(DATA_KEY) ? "toggle" : $.extend({}, $(target).data(), $(this).data());
                    if (this.tagName === "A" || this.tagName === "AREA") {
                        event.preventDefault();
                    }
                    var $target = $(target).one(Event.SHOW, function(showEvent) {
                        if (showEvent.isDefaultPrevented()) {
                            // only register focus restorer if modal will actually get shown
                            return;
                        }
                        $target.one(Event.HIDDEN, function() {
                            if ($(this).is(":visible")) {
                                this.focus();
                            }
                        });
                    });
                    Modal._jQueryInterface.call($(target), config, this);
                });
                /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */ $.fn[NAME] = Modal._jQueryInterface;
                $.fn[NAME].Constructor = Modal;
                $.fn[NAME].noConflict = function() {
                    $.fn[NAME] = JQUERY_NO_CONFLICT;
                    return Modal._jQueryInterface;
                };
                return Modal;
            }(jQuery);
            /**
 * --------------------------------------------------------------------------
 * Bootstrap (v4.0.0-alpha.6): scrollspy.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */ var ScrollSpy = function($) {
                /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */ var NAME = "scrollspy";
                var VERSION = "4.0.0-alpha.6";
                var DATA_KEY = "bs.scrollspy";
                var EVENT_KEY = "." + DATA_KEY;
                var DATA_API_KEY = ".data-api";
                var JQUERY_NO_CONFLICT = $.fn[NAME];
                var Default = {
                    offset: 10,
                    method: "auto",
                    target: ""
                };
                var DefaultType = {
                    offset: "number",
                    method: "string",
                    target: "(string|element)"
                };
                var Event = {
                    ACTIVATE: "activate" + EVENT_KEY,
                    SCROLL: "scroll" + EVENT_KEY,
                    LOAD_DATA_API: "load" + EVENT_KEY + DATA_API_KEY
                };
                var ClassName = {
                    DROPDOWN_ITEM: "dropdown-item",
                    DROPDOWN_MENU: "dropdown-menu",
                    NAV_LINK: "nav-link",
                    NAV: "nav",
                    ACTIVE: "active"
                };
                var Selector = {
                    DATA_SPY: '[data-spy="scroll"]',
                    ACTIVE: ".active",
                    LIST_ITEM: ".list-item",
                    LI: "li",
                    LI_DROPDOWN: "li.dropdown",
                    NAV_LINKS: ".nav-link",
                    DROPDOWN: ".dropdown",
                    DROPDOWN_ITEMS: ".dropdown-item",
                    DROPDOWN_TOGGLE: ".dropdown-toggle"
                };
                var OffsetMethod = {
                    OFFSET: "offset",
                    POSITION: "position"
                };
                /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */ var ScrollSpy = function() {
                    function ScrollSpy(element, config) {
                        _classCallCheck(this, ScrollSpy);
                        this._element = element;
                        this._scrollElement = element.tagName === "BODY" ? window : element;
                        this._config = this._getConfig(config);
                        this._selector = this._config.target + " " + Selector.NAV_LINKS + "," + (this._config.target + " " + Selector.DROPDOWN_ITEMS);
                        this._offsets = [];
                        this._targets = [];
                        this._activeTarget = null;
                        this._scrollHeight = 0;
                        $(this._scrollElement).on(Event.SCROLL, function(event) {
                            return this._process(event);
                        });
                        this.refresh();
                        this._process();
                    }
                    // getters
                    // public
                    ScrollSpy.prototype.refresh = function refresh() {
                        var autoMethod = this._scrollElement !== this._scrollElement.window ? OffsetMethod.POSITION : OffsetMethod.OFFSET;
                        var offsetMethod = this._config.method === "auto" ? autoMethod : this._config.method;
                        var offsetBase = offsetMethod === OffsetMethod.POSITION ? this._getScrollTop() : 0;
                        this._offsets = [];
                        this._targets = [];
                        this._scrollHeight = this._getScrollHeight();
                        var targets = $.makeArray($(this._selector));
                        targets.map(function(element) {
                            var target = void 0;
                            var targetSelector = Util.getSelectorFromElement(element);
                            if (targetSelector) {
                                target = $(targetSelector)[0];
                            }
                            if (target && (target.offsetWidth || target.offsetHeight)) {
                                // todo (fat): remove sketch reliance on jQuery position/offset
                                return [
                                    $(target)[offsetMethod]().top + offsetBase,
                                    targetSelector
                                ];
                            }
                            return null;
                        }).filter(function(item) {
                            return item;
                        }).sort(function(a, b) {
                            return a[0] - b[0];
                        }).forEach(function(item) {
                            this._offsets.push(item[0]);
                            this._targets.push(item[1]);
                        });
                    };
                    ScrollSpy.prototype.dispose = function dispose() {
                        $.removeData(this._element, DATA_KEY);
                        $(this._scrollElement).off(EVENT_KEY);
                        this._element = null;
                        this._scrollElement = null;
                        this._config = null;
                        this._selector = null;
                        this._offsets = null;
                        this._targets = null;
                        this._activeTarget = null;
                        this._scrollHeight = null;
                    };
                    // private
                    ScrollSpy.prototype._getConfig = function _getConfig(config) {
                        config = $.extend({}, Default, config);
                        if (typeof config.target !== "string") {
                            var id = $(config.target).attr("id");
                            if (!id) {
                                id = Util.getUID(NAME);
                                $(config.target).attr("id", id);
                            }
                            config.target = "#" + id;
                        }
                        Util.typeCheckConfig(NAME, config, DefaultType);
                        return config;
                    };
                    ScrollSpy.prototype._getScrollTop = function _getScrollTop() {
                        return this._scrollElement === window ? this._scrollElement.pageYOffset : this._scrollElement.scrollTop;
                    };
                    ScrollSpy.prototype._getScrollHeight = function _getScrollHeight() {
                        return this._scrollElement.scrollHeight || Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
                    };
                    ScrollSpy.prototype._getOffsetHeight = function _getOffsetHeight() {
                        return this._scrollElement === window ? window.innerHeight : this._scrollElement.offsetHeight;
                    };
                    ScrollSpy.prototype._process = function _process() {
                        var scrollTop = this._getScrollTop() + this._config.offset;
                        var scrollHeight = this._getScrollHeight();
                        var maxScroll = this._config.offset + scrollHeight - this._getOffsetHeight();
                        if (this._scrollHeight !== scrollHeight) {
                            this.refresh();
                        }
                        if (scrollTop >= maxScroll) {
                            var target = this._targets[this._targets.length - 1];
                            if (this._activeTarget !== target) {
                                this._activate(target);
                            }
                            return;
                        }
                        if (this._activeTarget && scrollTop < this._offsets[0] && this._offsets[0] > 0) {
                            this._activeTarget = null;
                            this._clear();
                            return;
                        }
                        for(var i = this._offsets.length; i--;){
                            var isActiveTarget = this._activeTarget !== this._targets[i] && scrollTop >= this._offsets[i] && (this._offsets[i + 1] === undefined || scrollTop < this._offsets[i + 1]);
                            if (isActiveTarget) {
                                this._activate(this._targets[i]);
                            }
                        }
                    };
                    ScrollSpy.prototype._activate = function _activate(target) {
                        this._activeTarget = target;
                        this._clear();
                        var queries = this._selector.split(",");
                        queries = queries.map(function(selector) {
                            return selector + '[data-target="' + target + '"],' + (selector + '[href="' + target + '"]');
                        });
                        var $link = $(queries.join(","));
                        if ($link.hasClass(ClassName.DROPDOWN_ITEM)) {
                            $link.closest(Selector.DROPDOWN).find(Selector.DROPDOWN_TOGGLE).addClass(ClassName.ACTIVE);
                            $link.addClass(ClassName.ACTIVE);
                        } else {
                            // todo (fat) this is kinda sus...
                            // recursively add actives to tested nav-links
                            $link.parents(Selector.LI).find("> " + Selector.NAV_LINKS).addClass(ClassName.ACTIVE);
                        }
                        $(this._scrollElement).trigger(Event.ACTIVATE, {
                            relatedTarget: target
                        });
                    };
                    ScrollSpy.prototype._clear = function _clear() {
                        $(this._selector).filter(Selector.ACTIVE).removeClass(ClassName.ACTIVE);
                    };
                    // static
                    ScrollSpy._jQueryInterface = function _jQueryInterface(config) {
                        return this.each(function() {
                            var data = $(this).data(DATA_KEY);
                            var _config = (typeof config === "undefined" ? "undefined" : _typeof(config)) === "object" && config;
                            if (!data) {
                                data = new ScrollSpy(this, _config);
                                $(this).data(DATA_KEY, data);
                            }
                            if (typeof config === "string") {
                                if (data[config] === undefined) {
                                    throw new Error('No method named "' + config + '"');
                                }
                                data[config]();
                            }
                        });
                    };
                    _createClass(ScrollSpy, null, [
                        {
                            key: "VERSION",
                            get: function get() {
                                return VERSION;
                            }
                        },
                        {
                            key: "Default",
                            get: function get() {
                                return Default;
                            }
                        }
                    ]);
                    return ScrollSpy;
                }();
                /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */ $(window).on(Event.LOAD_DATA_API, function() {
                    var scrollSpys = $.makeArray($(Selector.DATA_SPY));
                    for(var i = scrollSpys.length; i--;){
                        var $spy = $(scrollSpys[i]);
                        ScrollSpy._jQueryInterface.call($spy, $spy.data());
                    }
                });
                /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */ $.fn[NAME] = ScrollSpy._jQueryInterface;
                $.fn[NAME].Constructor = ScrollSpy;
                $.fn[NAME].noConflict = function() {
                    $.fn[NAME] = JQUERY_NO_CONFLICT;
                    return ScrollSpy._jQueryInterface;
                };
                return ScrollSpy;
            }(jQuery);
            /**
 * --------------------------------------------------------------------------
 * Bootstrap (v4.0.0-alpha.6): tab.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */ var Tab = function($) {
                /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */ var NAME = "tab";
                var VERSION = "4.0.0-alpha.6";
                var DATA_KEY = "bs.tab";
                var EVENT_KEY = "." + DATA_KEY;
                var DATA_API_KEY = ".data-api";
                var JQUERY_NO_CONFLICT = $.fn[NAME];
                var TRANSITION_DURATION = 150;
                var Event = {
                    HIDE: "hide" + EVENT_KEY,
                    HIDDEN: "hidden" + EVENT_KEY,
                    SHOW: "show" + EVENT_KEY,
                    SHOWN: "shown" + EVENT_KEY,
                    CLICK_DATA_API: "click" + EVENT_KEY + DATA_API_KEY
                };
                var ClassName = {
                    DROPDOWN_MENU: "dropdown-menu",
                    ACTIVE: "active",
                    DISABLED: "disabled",
                    FADE: "fade",
                    SHOW: "show"
                };
                var Selector = {
                    A: "a",
                    LI: "li",
                    DROPDOWN: ".dropdown",
                    LIST: "ul:not(.dropdown-menu), ol:not(.dropdown-menu), nav:not(.dropdown-menu)",
                    FADE_CHILD: "> .nav-item .fade, > .fade",
                    ACTIVE: ".active",
                    ACTIVE_CHILD: "> .nav-item > .active, > .active",
                    DATA_TOGGLE: '[data-toggle="tab"], [data-toggle="pill"]',
                    DROPDOWN_TOGGLE: ".dropdown-toggle",
                    DROPDOWN_ACTIVE_CHILD: "> .dropdown-menu .active"
                };
                /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */ var Tab = function() {
                    function Tab(element) {
                        _classCallCheck(this, Tab);
                        this._element = element;
                    }
                    // getters
                    // public
                    Tab.prototype.show = function show() {
                        if (this._element.parentNode && this._element.parentNode.nodeType === Node.ELEMENT_NODE && $(this._element).hasClass(ClassName.ACTIVE) || $(this._element).hasClass(ClassName.DISABLED)) {
                            return;
                        }
                        var target = void 0;
                        var previous = void 0;
                        var listElement = $(this._element).closest(Selector.LIST)[0];
                        var selector = Util.getSelectorFromElement(this._element);
                        if (listElement) {
                            previous = $.makeArray($(listElement).find(Selector.ACTIVE));
                            previous = previous[previous.length - 1];
                        }
                        var hideEvent = $.Event(Event.HIDE, {
                            relatedTarget: this._element
                        });
                        var showEvent = $.Event(Event.SHOW, {
                            relatedTarget: previous
                        });
                        if (previous) {
                            $(previous).trigger(hideEvent);
                        }
                        $(this._element).trigger(showEvent);
                        if (showEvent.isDefaultPrevented() || hideEvent.isDefaultPrevented()) {
                            return;
                        }
                        if (selector) {
                            target = $(selector)[0];
                        }
                        this._activate(this._element, listElement);
                        var complete = function complete() {
                            var hiddenEvent = $.Event(Event.HIDDEN, {
                                relatedTarget: this._element
                            });
                            var shownEvent = $.Event(Event.SHOWN, {
                                relatedTarget: previous
                            });
                            $(previous).trigger(hiddenEvent);
                            $(this._element).trigger(shownEvent);
                        };
                        if (target) {
                            this._activate(target, target.parentNode, complete);
                        } else {
                            complete();
                        }
                    };
                    Tab.prototype.dispose = function dispose() {
                        $.removeClass(this._element, DATA_KEY);
                        this._element = null;
                    };
                    // private
                    Tab.prototype._activate = function _activate(element, container, callback) {
                        var active = $(container).find(Selector.ACTIVE_CHILD)[0];
                        var isTransitioning = callback && Util.supportsTransitionEnd() && (active && $(active).hasClass(ClassName.FADE) || Boolean($(container).find(Selector.FADE_CHILD)[0]));
                        var complete = function complete() {
                            return this._transitionComplete(element, active, isTransitioning, callback);
                        };
                        if (active && isTransitioning) {
                            $(active).one(Util.TRANSITION_END, complete).emulateTransitionEnd(TRANSITION_DURATION);
                        } else {
                            complete();
                        }
                        if (active) {
                            $(active).removeClass(ClassName.SHOW);
                        }
                    };
                    Tab.prototype._transitionComplete = function _transitionComplete(element, active, isTransitioning, callback) {
                        if (active) {
                            $(active).removeClass(ClassName.ACTIVE);
                            var dropdownChild = $(active.parentNode).find(Selector.DROPDOWN_ACTIVE_CHILD)[0];
                            if (dropdownChild) {
                                $(dropdownChild).removeClass(ClassName.ACTIVE);
                            }
                            active.setAttribute("aria-expanded", false);
                        }
                        $(element).addClass(ClassName.ACTIVE);
                        element.setAttribute("aria-expanded", true);
                        if (isTransitioning) {
                            Util.reflow(element);
                            $(element).addClass(ClassName.SHOW);
                        } else {
                            $(element).removeClass(ClassName.FADE);
                        }
                        if (element.parentNode && $(element.parentNode).hasClass(ClassName.DROPDOWN_MENU)) {
                            var dropdownElement = $(element).closest(Selector.DROPDOWN)[0];
                            if (dropdownElement) {
                                $(dropdownElement).find(Selector.DROPDOWN_TOGGLE).addClass(ClassName.ACTIVE);
                            }
                            element.setAttribute("aria-expanded", true);
                        }
                        if (callback) {
                            callback();
                        }
                    };
                    // static
                    Tab._jQueryInterface = function _jQueryInterface(config) {
                        return this.each(function() {
                            var $this = $(this);
                            var data = $this.data(DATA_KEY);
                            if (!data) {
                                data = new Tab(this);
                                $this.data(DATA_KEY, data);
                            }
                            if (typeof config === "string") {
                                if (data[config] === undefined) {
                                    throw new Error('No method named "' + config + '"');
                                }
                                data[config]();
                            }
                        });
                    };
                    _createClass(Tab, null, [
                        {
                            key: "VERSION",
                            get: function get() {
                                return VERSION;
                            }
                        }
                    ]);
                    return Tab;
                }();
                /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */ $(document).on(Event.CLICK_DATA_API, Selector.DATA_TOGGLE, function(event) {
                    event.preventDefault();
                    Tab._jQueryInterface.call($(this), "show");
                });
                /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */ $.fn[NAME] = Tab._jQueryInterface;
                $.fn[NAME].Constructor = Tab;
                $.fn[NAME].noConflict = function() {
                    $.fn[NAME] = JQUERY_NO_CONFLICT;
                    return Tab._jQueryInterface;
                };
                return Tab;
            }(jQuery);
        }();
    }
};


;// CONCATENATED MODULE: ./components/RBPartnerPortal/templates/AutoraTemplate/AutoraLayout.tsx
/* eslint-disable @next/next/no-css-tags */ 








var AutoraLayout = function(param) {
    var children = param.children;
    var partnerSiteFull = (0,LayoutContext/* useLayoutData */.Qq)().partnerSiteFull;
    var ref = (0,react.useState)("#f4511e"), mainColor = ref[0], setMainColor = ref[1];
    var ref1 = (0,react.useState)("#000000"), secondaryColor = ref1[0], setSecondaryColor = ref1[1];
    var ref2 = (0,react.useState)("#777777"), textColor = ref2[0], setTextColor = ref2[1];
    var ref3 = (0,react.useState)("#000000"), titleColor = ref3[0], setTitleColor = ref3[1];
    var TopBar = dynamic_default()(function() {
        return __webpack_require__.e(/* import() */ 1427).then(__webpack_require__.bind(__webpack_require__, 61427));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(61427)
                ];
            }
        }
    });
    var BottomBar = dynamic_default()(function() {
        return __webpack_require__.e(/* import() */ 6608).then(__webpack_require__.bind(__webpack_require__, 76608));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(76608)
                ];
            }
        }
    });
    var Header = dynamic_default()(function() {
        return __webpack_require__.e(/* import() */ 798).then(__webpack_require__.bind(__webpack_require__, 80798));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(80798)
                ];
            }
        }
    });
    var Footer = dynamic_default()(function() {
        return __webpack_require__.e(/* import() */ 9708).then(__webpack_require__.bind(__webpack_require__, 99708));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(99708)
                ];
            }
        }
    });
    var setColors = function() {
        setMainColor(function(prevMainColor) {
            var ref;
            return (ref = colorSetter(partnerSiteFull, "mainColor")) !== null && ref !== void 0 ? ref : prevMainColor;
        });
        setSecondaryColor(function(prevSecondaryColor) {
            var ref;
            return (ref = colorSetter(partnerSiteFull, "secondaryColor")) !== null && ref !== void 0 ? ref : prevSecondaryColor;
        });
        setTextColor(function(prevTextColor) {
            var ref;
            return (ref = colorSetter(partnerSiteFull, "textColor")) !== null && ref !== void 0 ? ref : prevTextColor;
        });
        setTitleColor(function(prevTitleColor) {
            var ref;
            return (ref = colorSetter(partnerSiteFull, "titleColor")) !== null && ref !== void 0 ? ref : prevTitleColor;
        });
    };
    (0,react.useEffect)(function() {
        AutoraJS.init();
        bootstrap.init();
    }, []);
    (0,react.useEffect)(function() {
        setColors();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        partnerSiteFull
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                        children: "\n            :root {\n              --main-color: ".concat(mainColor, ";\n              --secondary-color: ").concat(secondaryColor, ";\n              --text-color: ").concat(textColor, ";\n              --title-color: ").concat(titleColor, ";\n            }\n          ")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "stylesheet",
                        type: "text/css",
                        href: "/templates/AutoraTemplate/assets/css/style.min.css"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "stylesheet",
                        type: "text/css",
                        href: "/templates/AutoraTemplate/assets/css/shortcodes.min.css"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                id: "layout-loader",
                sx: LoadingScreenStyle,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                    color: "inherit"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "header-fixed page no-sidebar header-style-2 topbar-style-1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        id: "wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            id: "page",
                            className: "clearfix",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    id: "site-header-wrap",
                                    children: [
                                        topBarAvailable(partnerSiteFull) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TopBar, {}) : null,
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {})
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    id: "main-content",
                                    className: "site-main clearfix",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        id: "content-wrap",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            id: "site-content",
                                            className: "site-content clearfix",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                id: "inner-content",
                                                className: "inner-content-wrap",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "page-content",
                                                    children: children
                                                })
                                            })
                                        })
                                    })
                                }),
                                topBarAvailable(partnerSiteFull) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {}) : null,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomBar, {})
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        id: "scroll-top"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var AutoraTemplate_AutoraLayout = (AutoraLayout);

// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/styled.js
var styled = __webpack_require__(81719);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Container/Container.js
var Container = __webpack_require__(78016);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(29630);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/RBPartnerPortal/templates/CastroTemplate/_layouts/Header/Header.tsx




var Header = function(param) {
    var openMobilMenu = param.openMobilMenu;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var partnerSiteFull = (0,LayoutContext/* useLayoutData */.Qq)().partnerSiteFull;
    var headerURL = (ref3 = partnerSiteFull === null || partnerSiteFull === void 0 ? void 0 : (ref = partnerSiteFull.content) === null || ref === void 0 ? void 0 : (ref1 = ref.templateProperties) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.items) === null || ref2 === void 0 ? void 0 : ref2.find(function(item) {
        return item.key === "headerURL";
    })) === null || ref3 === void 0 ? void 0 : ref3.value;
    var headerImage = headerURL && headerURL !== "" ? headerURL : undefined;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "header-info-area",
            style: {
                backgroundImage: headerImage ? "url('".concat(headerImage, "')") : undefined
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container-fluid px-2 px-md-5",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "row align-items-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-lg-12",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "header-info-wrapper align-items-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "logo",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                    className: "h4 fw-bold mb-0",
                                                    children: partnerSiteFull === null || partnerSiteFull === void 0 ? void 0 : (ref4 = partnerSiteFull.partnerSite) === null || ref4 === void 0 ? void 0 : ref4.name
                                                }),
                                                isSubNameAvailable(partnerSiteFull) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "h6",
                                                    children: partnerSiteFull === null || partnerSiteFull === void 0 ? void 0 : (ref5 = partnerSiteFull.partnerSite) === null || ref5 === void 0 ? void 0 : ref5.subName
                                                }) : null
                                            ]
                                        })
                                    })
                                }),
                                topBarHasLeftData(partnerSiteFull) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "header-contact-info",
                                    children: partnerSiteFull === null || partnerSiteFull === void 0 ? void 0 : (ref6 = partnerSiteFull.content) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.topBar) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.items) === null || ref8 === void 0 ? void 0 : ref8.map(function(item, i) {
                                        if (!item.rightSide) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "header-info-single-item",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "header-info-single-item__icon",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                            className: "fa ".concat(item.ikon)
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "header-info-single-item__content",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                            className: "header-info-single-item__title pt-2",
                                                            children: item.title
                                                        })
                                                    })
                                                ]
                                            }, i);
                                        }
                                    })
                                }) : null,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mobile-navigation-icon",
                                    id: "mobile-menu-trigger",
                                    onClick: function() {
                                        return openMobilMenu();
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {})
                                })
                            ]
                        })
                    })
                })
            })
        })
    });
};
/* harmony default export */ var Header_Header = (Header);

;// CONCATENATED MODULE: ./components/RBPartnerPortal/templates/CastroTemplate/_layouts/TopBar/TopBar.tsx



var TopBar = function() {
    var ref, ref1, ref2;
    var partnerSiteFull = (0,LayoutContext/* useLayoutData */.Qq)().partnerSiteFull;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "header-top-bar",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container-fluid px-2 px-md-5",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "row align-items-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-lg-12",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "top-bar-left-wrapper py-2",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "social-links social-links--white-topbar d-inline-block",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    children: partnerSiteFull === null || partnerSiteFull === void 0 ? void 0 : (ref = partnerSiteFull.content) === null || ref === void 0 ? void 0 : (ref1 = ref.topBar) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.items) === null || ref2 === void 0 ? void 0 : ref2.map(function(item, i) {
                                        if (item.rightSide) {
                                            var _link;
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: (_link = item.link) !== null && _link !== void 0 ? _link : "/",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        target: "_blank",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                            className: "fa ".concat(item.ikon)
                                                        })
                                                    })
                                                })
                                            }, i);
                                        }
                                    })
                                })
                            })
                        })
                    })
                })
            })
        })
    });
};
/* harmony default export */ var TopBar_TopBar = (TopBar);

// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
;// CONCATENATED MODULE: ./components/RBPartnerPortal/templates/CastroTemplate/_layouts/Navbar/MenuList.tsx






var MenuList = function(param) {
    var mobile = param.mobile, closeMobilMenu = param.closeMobilMenu;
    var partnerSiteFull = (0,LayoutContext/* useLayoutData */.Qq)().partnerSiteFull;
    var page = (router_default()).query.page;
    var ref = (0,react.useState)(), mobileSubmenuOpen = ref[0], setMobilSubmenuOpen = ref[1];
    var handleToggleSubmenu = function(id) {
        setMobilSubmenuOpen(function(prevSubmenuOpen) {
            if (prevSubmenuOpen === id) return null;
            if (prevSubmenuOpen !== id) return id;
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: (partnerSiteFull === null || partnerSiteFull === void 0 ? void 0 : partnerSiteFull.pages) && partnerSiteFull.pages.map(function(menuPage, i) {
            var ref;
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("li", {
                className: "".concat(mobileSubmenuOpen === menuPage.id ? "active" : "", " ").concat(componentShowInMenu(menuPage.id, partnerSiteFull) ? mobile ? "menu-item-has-children" : "has-children has-children--multilevel-submenu" : "", " ").concat(!mobile ? page ? page[0] === menuPage.urlName ? "active" : "" : i == 0 ? "active" : "" : ""),
                onClick: mobile ? componentShowInMenu(menuPage.id, partnerSiteFull) ? function() {
                    return handleToggleSubmenu(menuPage.id);
                } : function() {
                    return closeMobilMenu && closeMobilMenu();
                } : undefined,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: i == 0 ? "/" : menuPage.urlName ? "/" + menuPage.urlName : "/",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            children: menuPage.name
                        })
                    }),
                    componentShowInMenu(menuPage.id, partnerSiteFull) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            mobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "menu-expand",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {})
                            }) : null,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                className: mobile ? "sub-menu" : "submenu",
                                children: (partnerSiteFull === null || partnerSiteFull === void 0 ? void 0 : partnerSiteFull.components) && menuPage.id && ((ref = partnerSiteFull === null || partnerSiteFull === void 0 ? void 0 : partnerSiteFull.components[menuPage.id]) === null || ref === void 0 ? void 0 : ref.map(function(component, i) {
                                    if (component.enabled && component.showInMenu) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            onClick: function() {
                                                return closeMobilMenu && closeMobilMenu();
                                            },
                                            className: router_default().asPath.includes("#".concat(createSlug(component === null || component === void 0 ? void 0 : component.title))) ? "active" : "",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: menuPage.urlName ? "/" + menuPage.urlName + "#".concat(createSlug(component === null || component === void 0 ? void 0 : component.title)) : "/",
                                                children: component.title
                                            })
                                        }, i);
                                    }
                                }))
                            })
                        ]
                    }) : null
                ]
            }, i);
        })
    });
};
/* harmony default export */ var Navbar_MenuList = (MenuList);

;// CONCATENATED MODULE: ./components/RBPartnerPortal/templates/CastroTemplate/_layouts/Navbar/Menu.tsx


var Menu = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "header-navigation-area default-bg",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container-fluid px-5",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "row",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-lg-12",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "header-navigation header-navigation--header-default position-relative",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "header-navigation__nav position-static",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar_MenuList, {})
                                    })
                                })
                            })
                        })
                    })
                })
            })
        })
    });
};
/* harmony default export */ var Navbar_Menu = (Menu);

;// CONCATENATED MODULE: ./components/RBPartnerPortal/templates/CastroTemplate/_layouts/Navbar/MobilNavbar.tsx




var MobilNavbar = function(param) {
    var open = param.open, close = param.close;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var partnerSiteFull = (0,LayoutContext/* useLayoutData */.Qq)().partnerSiteFull;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "offcanvas-mobile-menu ".concat(open ? "active" : ""),
            id: "mobile-menu-overlay",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    onClick: function() {
                        return close();
                    },
                    className: "offcanvas-menu-close",
                    id: "mobile-menu-close-trigger",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        className: "ion-android-close"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "offcanvas-wrapper",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "offcanvas-inner-content",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                                className: "offcanvas-navigation",
                                id: "offcanvas-navigation",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar_MenuList, {
                                        closeMobilMenu: close,
                                        mobile: true
                                    })
                                })
                            }),
                            topBarAvailable(partnerSiteFull) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "offcanvas-widget-area",
                                children: [
                                    topBarHasLeftData(partnerSiteFull) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "off-canvas-contact-widget",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "header-contact-info",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                className: "header-contact-info__list",
                                                children: partnerSiteFull === null || partnerSiteFull === void 0 ? void 0 : (ref = partnerSiteFull.content) === null || ref === void 0 ? void 0 : (ref1 = ref.topBar) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.items) === null || ref2 === void 0 ? void 0 : ref2.map(function(item, i) {
                                                    if (!item.rightSide) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                            className: "d-block",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                    className: "fa ".concat(item.ikon)
                                                                }),
                                                                item.title
                                                            ]
                                                        }, i);
                                                    }
                                                })
                                            })
                                        })
                                    }) : null,
                                    topBarHasRightData(partnerSiteFull) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "off-canvas-widget-social",
                                        children: partnerSiteFull === null || partnerSiteFull === void 0 ? void 0 : (ref3 = partnerSiteFull.content) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.topBar) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.items) === null || ref5 === void 0 ? void 0 : ref5.map(function(item, i) {
                                            if (item.rightSide) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: item.link,
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                        className: "fa ".concat(item.ikon)
                                                    })
                                                }, i);
                                            }
                                        })
                                    }) : null
                                ]
                            }) : null
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Navbar_MobilNavbar = (MobilNavbar);

;// CONCATENATED MODULE: ./components/RBPartnerPortal/templates/CastroTemplate/_layouts/Navbar/Navbar.tsx








var Navbar = function() {
    var partnerSiteFull = (0,LayoutContext/* useLayoutData */.Qq)().partnerSiteFull;
    var ref = (0,react.useState)(false), mobilMenuOpen = ref[0], setMobilMenuOpen = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "header-area header-sticky header-sticky--default",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "header-area__desktop header-area__desktop--default",
                    children: [
                        topBarHasRightData(partnerSiteFull) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TopBar_TopBar, {}) : null,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_Header, {
                            openMobilMenu: function() {
                                return setMobilMenuOpen(true);
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar_Menu, {})
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar_MobilNavbar, {
                open: mobilMenuOpen,
                close: function() {
                    return setMobilMenuOpen(false);
                }
            })
        ]
    });
};
/* harmony default export */ var Navbar_Navbar = (Navbar);

;// CONCATENATED MODULE: ./components/RBPartnerPortal/templates/CastroTemplate/Castro.js
/* provided dependency */ var Castro_$ = __webpack_require__(19755);
var CastroJS = {
    init: function init() {
        this.config();
        this.events();
    },
    config: function config() {
        this.config = {
            $window: Castro_$(window),
            $document: Castro_$(document)
        };
    },
    events: function events() {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var self = this;
        self.config.$document.ready(function() {
            self.preLoader();
        });
    },
    preLoader: function preLoader() {
        Castro_$("#layout-loader").delay(1000).fadeOut(500);
    }
};


;// CONCATENATED MODULE: ./components/RBPartnerPortal/templates/CastroTemplate/CastroLayout.tsx
/* eslint-disable @next/next/no-css-tags */ 







var CastroLayout = function(param) {
    var children = param.children;
    var partnerSiteFull = (0,LayoutContext/* useLayoutData */.Qq)().partnerSiteFull;
    var ref = (0,react.useState)("#f4511e"), mainColor = ref[0], setMainColor = ref[1];
    var ref1 = (0,react.useState)("#000000"), titleColor = ref1[0], setTitleColor = ref1[1];
    var ref2 = (0,react.useState)("#000000"), headerInfoColor = ref2[0], setHeaderInfoColor = ref2[1];
    var ref3 = (0,react.useState)("#fff"), menuTextColor = ref3[0], setMenuTextColor = ref3[1];
    var setColors = function() {
        setMainColor(function(prevMainColor) {
            var ref;
            return (ref = colorSetter(partnerSiteFull, "mainColor")) !== null && ref !== void 0 ? ref : prevMainColor;
        });
        setTitleColor(function(prevTitleColor) {
            var ref;
            return (ref = colorSetter(partnerSiteFull, "titleColor")) !== null && ref !== void 0 ? ref : prevTitleColor;
        });
        setHeaderInfoColor(function(prevHeaderInfoColor) {
            var ref;
            return (ref = colorSetter(partnerSiteFull, "headerInfoColor")) !== null && ref !== void 0 ? ref : prevHeaderInfoColor;
        });
        setMenuTextColor(function(prevMenuTextColor) {
            var ref;
            return (ref = colorSetter(partnerSiteFull, "menuTextColor")) !== null && ref !== void 0 ? ref : prevMenuTextColor;
        });
    };
    (0,react.useEffect)(function() {
        CastroJS.init();
    }, []);
    (0,react.useEffect)(function() {
        setColors();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        partnerSiteFull
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                        children: "\n            :root {\n              --main-color: ".concat(mainColor, ";\n              --title-color: ").concat(titleColor, ";\n              --header-info-color: ").concat(headerInfoColor, ";\n              --menu-text-color: ").concat(menuTextColor, ";\n            }\n          ")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "stylesheet",
                        type: "text/css",
                        href: "/templates/CastroTemplate/assets/css/style.min.css"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                id: "layout-loader",
                sx: LoadingScreenStyle,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                    color: "inherit"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar_Navbar, {}),
            children
        ]
    });
};
/* harmony default export */ var CastroTemplate_CastroLayout = (CastroLayout);

// EXTERNAL MODULE: ./node_modules/@mui/material/esm/colors/common.js
var common = __webpack_require__(66869);
;// CONCATENATED MODULE: ./components/RBPartnerPortal/PartnerPortalLayout.tsx
/* eslint-disable @typescript-eslint/no-explicit-any */ 






var Weekdays = {
    1: "H\xe9tfő",
    2: "Kedd",
    3: "Szerda",
    4: "Cs\xfct\xfcrt\xf6k",
    5: "P\xe9ntek",
    6: "Szombat",
    7: "Vas\xe1rnap"
};
var LoadingScreenStyle = {
    alignItems: "center",
    background: common/* default.white */.Z.white,
    display: "flex",
    height: "100vh",
    justifyContent: "center",
    position: "fixed",
    width: "100%",
    zIndex: 10000
};
var PartnerPortalDisabledContainer = (0,styled/* default */.ZP)(Box/* default */.Z)(function(param) {
    var theme = param.theme;
    return {
        backgroundColor: theme.palette.mode === "light" ? theme.palette.grey[300] : theme.palette.grey[900],
        marginTop: "5rem",
        padding: "4rem 2rem"
    };
});
// Ide kell betölteni a partnerPortalTemplates.ts fájl alapján a template-ek layout-ját
// az alapértelmezett layout az Autora
var getPartnerPortalLayout = function(children, templateId) {
    switch(templateId){
        case "AutoraTemplate":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoraTemplate_AutoraLayout, {
                children: children
            });
            break;
        case "CastroTemplate":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CastroTemplate_CastroLayout, {
                children: children
            });
            break;
        default:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoraTemplate_AutoraLayout, {
                children: children
            });
    }
};
var colorSetter = function(data, colorType) {
    var ref, ref1, ref2;
    var color = data === null || data === void 0 ? void 0 : (ref = data.content) === null || ref === void 0 ? void 0 : (ref1 = ref.templateProperties) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.items) === null || ref2 === void 0 ? void 0 : ref2.find(function(item) {
        if (item.key === colorType) return item.value && item.value !== "" ? item.value : null;
    });
    var ref3;
    return (ref3 = color === null || color === void 0 ? void 0 : color.value) !== null && ref3 !== void 0 ? ref3 : null;
};
var componentShowInMenu = function(id, partnerSiteFull) {
    return (partnerSiteFull === null || partnerSiteFull === void 0 ? void 0 : partnerSiteFull.components) && id && (partnerSiteFull === null || partnerSiteFull === void 0 ? void 0 : partnerSiteFull.components[id].some(function(component) {
        return component.enabled && component.showInMenu;
    }));
};
var isSubNameAvailable = function(partnerSiteFull) {
    var ref, ref1;
    return (partnerSiteFull === null || partnerSiteFull === void 0 ? void 0 : (ref = partnerSiteFull.partnerSite) === null || ref === void 0 ? void 0 : ref.subName) && (partnerSiteFull === null || partnerSiteFull === void 0 ? void 0 : (ref1 = partnerSiteFull.partnerSite) === null || ref1 === void 0 ? void 0 : ref1.subName) !== "";
};
var createSlug = function(string) {
    return string === null || string === void 0 ? void 0 : string.toString().toLowerCase().trim().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/\s+/g, "-").replace(/&/g, "-and-").replace(/[^\w\-]+/g, "").replace(/\-\-+/g, "-");
};
var topBarAvailable = function(partnerSiteFull) {
    var ref, ref1;
    return (partnerSiteFull === null || partnerSiteFull === void 0 ? void 0 : (ref = partnerSiteFull.content) === null || ref === void 0 ? void 0 : (ref1 = ref.topBar) === null || ref1 === void 0 ? void 0 : ref1.items) && partnerSiteFull.content.topBar.items.length > 0;
};
var topBarHasRightData = function(partnerSiteFull) {
    var ref, ref1, ref2;
    return partnerSiteFull === null || partnerSiteFull === void 0 ? void 0 : (ref = partnerSiteFull.content) === null || ref === void 0 ? void 0 : (ref1 = ref.topBar) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.items) === null || ref2 === void 0 ? void 0 : ref2.find(function(items) {
        return items.rightSide === true;
    });
};
var topBarHasLeftData = function(partnerSiteFull) {
    var ref, ref1, ref2;
    return partnerSiteFull === null || partnerSiteFull === void 0 ? void 0 : (ref = partnerSiteFull.content) === null || ref === void 0 ? void 0 : (ref1 = ref.topBar) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.items) === null || ref2 === void 0 ? void 0 : ref2.find(function(items) {
        return items.rightSide === false;
    });
};
var PartnerPortalLayout = function(param) {
    var children = param.children;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12;
    var ref13 = (0,LayoutContext/* useLayoutData */.Qq)(), error = ref13.error, partnerSiteFull = ref13.partnerSiteFull;
    var favicon = (partnerSiteFull === null || partnerSiteFull === void 0 ? void 0 : (ref = partnerSiteFull.content) === null || ref === void 0 ? void 0 : ref.favicon) && (partnerSiteFull === null || partnerSiteFull === void 0 ? void 0 : (ref1 = partnerSiteFull.content) === null || ref1 === void 0 ? void 0 : ref1.favicon) !== "" ? partnerSiteFull === null || partnerSiteFull === void 0 ? void 0 : (ref2 = partnerSiteFull.content) === null || ref2 === void 0 ? void 0 : ref2.favicon : null;
    var data = partnerSiteFull === null || partnerSiteFull === void 0 ? void 0 : (ref3 = partnerSiteFull.content) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.favicon) === null || ref4 === void 0 ? void 0 : ref4.split(";")[0];
    var type = data === null || data === void 0 ? void 0 : data.split(":")[1];
    var showDescriptionMeta = !error && (partnerSiteFull === null || partnerSiteFull === void 0 ? void 0 : (ref5 = partnerSiteFull.content) === null || ref5 === void 0 ? void 0 : ref5.htmlDescription) && (partnerSiteFull === null || partnerSiteFull === void 0 ? void 0 : (ref6 = partnerSiteFull.content) === null || ref6 === void 0 ? void 0 : ref6.htmlDescription) !== "";
    var hasHtmlTitle = (partnerSiteFull === null || partnerSiteFull === void 0 ? void 0 : (ref7 = partnerSiteFull.content) === null || ref7 === void 0 ? void 0 : ref7.htmlTitle) && (partnerSiteFull === null || partnerSiteFull === void 0 ? void 0 : (ref8 = partnerSiteFull.content) === null || ref8 === void 0 ? void 0 : ref8.htmlTitle) !== "";
    var ref14, ref15;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        charSet: "UTF-8"
                    }),
                    showDescriptionMeta ? /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: partnerSiteFull === null || partnerSiteFull === void 0 ? void 0 : (ref9 = partnerSiteFull.content) === null || ref9 === void 0 ? void 0 : ref9.htmlDescription
                    }) : undefined,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "viewport",
                        content: "width=device-width, initial-scale=1.0"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: !error ? hasHtmlTitle ? partnerSiteFull === null || partnerSiteFull === void 0 ? void 0 : (ref10 = partnerSiteFull.content) === null || ref10 === void 0 ? void 0 : ref10.htmlTitle : partnerSiteFull === null || partnerSiteFull === void 0 ? void 0 : (ref11 = partnerSiteFull.partnerSite) === null || ref11 === void 0 ? void 0 : ref11.name : "Racing Baz\xe1r PartnerPort\xe1l - ".concat((ref14 = error === null || error === void 0 ? void 0 : error.UIMessage) !== null && ref14 !== void 0 ? ref14 : "Ez az oldal nem l\xe9tezik.")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        type: "".concat(favicon ? type : "image/x-icon"),
                        href: favicon !== null && favicon !== void 0 ? favicon : "/partnerPortalFavicon.ico",
                        sizes: "16x16"
                    })
                ]
            }),
            !error ? getPartnerPortalLayout(children, partnerSiteFull === null || partnerSiteFull === void 0 ? void 0 : (ref12 = partnerSiteFull.content) === null || ref12 === void 0 ? void 0 : ref12.templateId) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerPortalDisabledContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                        maxWidth: "xl",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "h2",
                                children: "Racing Baz\xe1r PartnerPort\xe1l"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "h5",
                                children: (ref15 = error === null || error === void 0 ? void 0 : error.UIMessage) !== null && ref15 !== void 0 ? ref15 : "Ez az oldal nem l\xe9tezik."
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var RBPartnerPortal_PartnerPortalLayout = (PartnerPortalLayout);


/***/ })

}]);